export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  public: {
    Tables: {
      absences: {
        Row: {
          absenceTypeId: string | null
          category: Database["public"]["Enums"]["absenceCategory"] | null
          createdAt: string
          createdBy: string | null
          endDate: string
          halfDayEnd: boolean
          halfDayStart: boolean
          id: string
          orgId: string
          startDate: string
          state: Database["public"]["Enums"]["absenceState"]
          updatedAt: string | null
          updatedBy: string | null
          userId: string
        }
        Insert: {
          absenceTypeId?: string | null
          category?: Database["public"]["Enums"]["absenceCategory"] | null
          createdAt?: string
          createdBy?: string | null
          endDate: string
          halfDayEnd?: boolean
          halfDayStart?: boolean
          id?: string
          orgId?: string
          startDate: string
          state?: Database["public"]["Enums"]["absenceState"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
        }
        Update: {
          absenceTypeId?: string | null
          category?: Database["public"]["Enums"]["absenceCategory"] | null
          createdAt?: string
          createdBy?: string | null
          endDate?: string
          halfDayEnd?: boolean
          halfDayStart?: boolean
          id?: string
          orgId?: string
          startDate?: string
          state?: Database["public"]["Enums"]["absenceState"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "absences_absence_type_id_absence_types_id_fkey"
            columns: ["absenceTypeId"]
            isOneToOne: false
            referencedRelation: "absenceTypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "absences_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "absences_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "absences_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "absences_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      absenceTypes: {
        Row: {
          category: Database["public"]["Enums"]["absenceCategory"]
          createdAt: string
          createdBy: string | null
          deductsFromBalance: boolean
          id: string
          name: string
          orgId: string
          requiresApproval: boolean
          requiresDocument: boolean
          state: Database["public"]["Enums"]["state"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          category: Database["public"]["Enums"]["absenceCategory"]
          createdAt?: string
          createdBy?: string | null
          deductsFromBalance?: boolean
          id?: string
          name: string
          orgId?: string
          requiresApproval?: boolean
          requiresDocument?: boolean
          state?: Database["public"]["Enums"]["state"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          category?: Database["public"]["Enums"]["absenceCategory"]
          createdAt?: string
          createdBy?: string | null
          deductsFromBalance?: boolean
          id?: string
          name?: string
          orgId?: string
          requiresApproval?: boolean
          requiresDocument?: boolean
          state?: Database["public"]["Enums"]["state"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "absence_types_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "absence_types_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "absence_types_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      accounts: {
        Row: {
          accessToken: string | null
          accessTokenExpiresAt: string | null
          accountId: string
          badgeId: string
          createdAt: string
          id: string
          idToken: string | null
          password: string | null
          pin: string
          providerId: string
          refreshToken: string | null
          refreshTokenExpiresAt: string | null
          scope: string | null
          updatedAt: string
          userId: string
        }
        Insert: {
          accessToken?: string | null
          accessTokenExpiresAt?: string | null
          accountId: string
          badgeId?: string
          createdAt?: string
          id: string
          idToken?: string | null
          password?: string | null
          pin?: string
          providerId: string
          refreshToken?: string | null
          refreshTokenExpiresAt?: string | null
          scope?: string | null
          updatedAt: string
          userId: string
        }
        Update: {
          accessToken?: string | null
          accessTokenExpiresAt?: string | null
          accountId?: string
          badgeId?: string
          createdAt?: string
          id?: string
          idToken?: string | null
          password?: string | null
          pin?: string
          providerId?: string
          refreshToken?: string | null
          refreshTokenExpiresAt?: string | null
          scope?: string | null
          updatedAt?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "accounts_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleFiles: {
        Row: {
          articleId: string
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleId: string
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleId?: string
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "article_files_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleGroups: {
        Row: {
          createdAt: string
          createdBy: string | null
          description: string | null
          id: string
          name: string
          number: number
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          description?: string | null
          id?: string
          name: string
          number: number
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          description?: string | null
          id?: string
          name?: string
          number?: number
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "article_groups_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_groups_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_groups_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleLocations: {
        Row: {
          articleId: string
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
          warehouseLocationId: string
        }
        Insert: {
          articleId: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          warehouseLocationId: string
        }
        Update: {
          articleId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          warehouseLocationId?: string
        }
        Relationships: [
          {
            foreignKeyName: "article_locations_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_locations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_locations_hNfTJsdezugA_fkey"
            columns: ["warehouseLocationId"]
            isOneToOne: false
            referencedRelation: "warehouseLocations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_locations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_locations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleLocationStockBalances: {
        Row: {
          articleLocationId: string
          id: string
          orgId: string
          quantity: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleLocationId: string
          id?: string
          orgId?: string
          quantity: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleLocationId?: string
          id?: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "article_location_stock_balances_n7RhpHbEpYhg_fkey"
            columns: ["articleLocationId"]
            isOneToOne: true
            referencedRelation: "articleLocations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_balances_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_balances_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleLocationStockTransactions: {
        Row: {
          articleLocationId: string
          createdAt: string
          createdBy: string | null
          id: string
          operation: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId: string
          quantity: number
          returnOrderId: string | null
          suborderId: string | null
          type: Database["public"]["Enums"]["transactionType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleLocationId: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          operation: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId?: string
          quantity?: number
          returnOrderId?: string | null
          suborderId?: string | null
          type: Database["public"]["Enums"]["transactionType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleLocationId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          operation?: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId?: string
          quantity?: number
          returnOrderId?: string | null
          suborderId?: string | null
          type?: Database["public"]["Enums"]["transactionType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "article_location_stock_transactions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_transactions_lhmsOSyqEfee_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_transactions_QxdnDpbehN9E_fkey"
            columns: ["articleLocationId"]
            isOneToOne: false
            referencedRelation: "articleLocations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_transactions_rJWg1jn7AmE3_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_transactions_se8bFZC5S0gw_fkey"
            columns: ["returnOrderId"]
            isOneToOne: false
            referencedRelation: "returnOrders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_location_stock_transactions_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleProductTypes: {
        Row: {
          articleGroupId: string
          createdAt: string
          createdBy: string | null
          description: string | null
          id: string
          name: string
          number: number
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleGroupId: string
          createdAt?: string
          createdBy?: string | null
          description?: string | null
          id?: string
          name: string
          number: number
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleGroupId?: string
          createdAt?: string
          createdBy?: string | null
          description?: string | null
          id?: string
          name?: string
          number?: number
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "article_product_types_article_group_id_article_groups_id_fkey"
            columns: ["articleGroupId"]
            isOneToOne: false
            referencedRelation: "articleGroups"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_product_types_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_product_types_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_product_types_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articles: {
        Row: {
          articleProductTypeId: string
          createdAt: string
          createdBy: string | null
          depth: number | null
          description: string | null
          height: number | null
          id: string
          minimumStockBalance: number
          name: string
          number: number
          orgId: string
          requiresTransferCarrierOnReturn: boolean
          sizeUnit: Database["public"]["Enums"]["unit"] | null
          updatedAt: string | null
          updatedBy: string | null
          warningStockBalance: number
          weight: number | null
          weightUnit: Database["public"]["Enums"]["unit"] | null
          width: number | null
        }
        Insert: {
          articleProductTypeId?: string
          createdAt?: string
          createdBy?: string | null
          depth?: number | null
          description?: string | null
          height?: number | null
          id?: string
          minimumStockBalance: number
          name: string
          number: number
          orgId?: string
          requiresTransferCarrierOnReturn?: boolean
          sizeUnit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
          warningStockBalance: number
          weight?: number | null
          weightUnit?: Database["public"]["Enums"]["unit"] | null
          width?: number | null
        }
        Update: {
          articleProductTypeId?: string
          createdAt?: string
          createdBy?: string | null
          depth?: number | null
          description?: string | null
          height?: number | null
          id?: string
          minimumStockBalance?: number
          name?: string
          number?: number
          orgId?: string
          requiresTransferCarrierOnReturn?: boolean
          sizeUnit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
          warningStockBalance?: number
          weight?: number | null
          weightUnit?: Database["public"]["Enums"]["unit"] | null
          width?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "articles_article_product_type_id_article_product_types_id_fkey"
            columns: ["articleProductTypeId"]
            isOneToOne: false
            referencedRelation: "articleProductTypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "articles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "articles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "articles_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleStockBalances: {
        Row: {
          articleId: string
          id: string
          orgId: string
          quantity: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleId?: string
          id?: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleId?: string
          id?: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "article_stock_balances_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: true
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_stock_balances_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_stock_balances_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      articleStockBalancesHistory: {
        Row: {
          articleId: string
          articleStockBalanceId: string
          createdAt: string
          date: string
          id: string
          orgId: string
          quantity: number
        }
        Insert: {
          articleId?: string
          articleStockBalanceId: string
          createdAt?: string
          date?: string
          id?: string
          orgId?: string
          quantity: number
        }
        Update: {
          articleId?: string
          articleStockBalanceId?: string
          createdAt?: string
          date?: string
          id?: string
          orgId?: string
          quantity?: number
        }
        Relationships: [
          {
            foreignKeyName: "article_stock_balances_history_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_stock_balances_history_k8F5NGkkc3wP_fkey"
            columns: ["articleStockBalanceId"]
            isOneToOne: false
            referencedRelation: "articleStockBalances"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "article_stock_balances_history_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      attendances: {
        Row: {
          approvedAt: string | null
          approvedBy: string | null
          commuteTarget:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
          createdAt: string
          createdBy: string | null
          endCoordinates: unknown
          endSource: Database["public"]["Enums"]["attendanceSource"] | null
          endTime: string | null
          id: string
          isAutomatic: boolean
          orgId: string
          projectId: string | null
          rejectedAt: string | null
          rejectedBy: string | null
          rejectedReason: string | null
          seconds: number | null
          startCoordinates: unknown
          startSource: Database["public"]["Enums"]["attendanceSource"] | null
          startTime: string
          state: Database["public"]["Enums"]["attendanceState"]
          type: Database["public"]["Enums"]["attendanceType"]
          updatedAt: string | null
          updatedBy: string | null
          userId: string
          worksite: Database["public"]["Enums"]["attendanceWorksiteType"] | null
        }
        Insert: {
          approvedAt?: string | null
          approvedBy?: string | null
          commuteTarget?:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
          createdAt?: string
          createdBy?: string | null
          endCoordinates?: unknown
          endSource?: Database["public"]["Enums"]["attendanceSource"] | null
          endTime?: string | null
          id?: string
          isAutomatic?: boolean
          orgId?: string
          projectId?: string | null
          rejectedAt?: string | null
          rejectedBy?: string | null
          rejectedReason?: string | null
          seconds?: number | null
          startCoordinates?: unknown
          startSource?: Database["public"]["Enums"]["attendanceSource"] | null
          startTime: string
          state?: Database["public"]["Enums"]["attendanceState"]
          type: Database["public"]["Enums"]["attendanceType"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId: string
          worksite?:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
        }
        Update: {
          approvedAt?: string | null
          approvedBy?: string | null
          commuteTarget?:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
          createdAt?: string
          createdBy?: string | null
          endCoordinates?: unknown
          endSource?: Database["public"]["Enums"]["attendanceSource"] | null
          endTime?: string | null
          id?: string
          isAutomatic?: boolean
          orgId?: string
          projectId?: string | null
          rejectedAt?: string | null
          rejectedBy?: string | null
          rejectedReason?: string | null
          seconds?: number | null
          startCoordinates?: unknown
          startSource?: Database["public"]["Enums"]["attendanceSource"] | null
          startTime?: string
          state?: Database["public"]["Enums"]["attendanceState"]
          type?: Database["public"]["Enums"]["attendanceType"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
          worksite?:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
        }
        Relationships: [
          {
            foreignKeyName: "attendances_approved_by_users_id_fkey"
            columns: ["approvedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "attendances_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "attendances_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "attendances_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "attendances_rejected_by_users_id_fkey"
            columns: ["rejectedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "attendances_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "attendances_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      cityCoordinates: {
        Row: {
          city: string
          geometry: unknown
          id: string
        }
        Insert: {
          city: string
          geometry: unknown
          id?: string
        }
        Update: {
          city?: string
          geometry?: unknown
          id?: string
        }
        Relationships: []
      }
      contactBankAccounts: {
        Row: {
          accountHolder: string | null
          bankName: string | null
          bic: string | null
          contactId: string
          createdAt: string
          createdBy: string | null
          iban: string
          id: string
          incomingInvoiceId: string | null
          isDefault: boolean
          orgId: string
          source: Database["public"]["Enums"]["contactBankAccountSource"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          accountHolder?: string | null
          bankName?: string | null
          bic?: string | null
          contactId: string
          createdAt?: string
          createdBy?: string | null
          iban: string
          id?: string
          incomingInvoiceId?: string | null
          isDefault?: boolean
          orgId?: string
          source: Database["public"]["Enums"]["contactBankAccountSource"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          accountHolder?: string | null
          bankName?: string | null
          bic?: string | null
          contactId?: string
          createdAt?: string
          createdBy?: string | null
          iban?: string
          id?: string
          incomingInvoiceId?: string | null
          isDefault?: boolean
          orgId?: string
          source?: Database["public"]["Enums"]["contactBankAccountSource"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contact_bank_accounts_contact_id_contacts_id_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_bank_accounts_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_bank_accounts_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_bank_accounts_RLMg8mnFDCpX_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_bank_accounts_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      contactMemberAuthorizations: {
        Row: {
          authorizationTypeId: string
          contactMemberId: string
          id: string
          orgId: string
        }
        Insert: {
          authorizationTypeId: string
          contactMemberId: string
          id?: string
          orgId?: string
        }
        Update: {
          authorizationTypeId?: string
          contactMemberId?: string
          id?: string
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "contact_member_authorizations_BSlpYiIvbwf5_fkey"
            columns: ["authorizationTypeId"]
            isOneToOne: false
            referencedRelation: "contactMemberAuthorizationTypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_member_authorizations_LjDSJqmdlI5d_fkey"
            columns: ["contactMemberId"]
            isOneToOne: false
            referencedRelation: "contactMembers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_member_authorizations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      contactMemberAuthorizationTypes: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string
          createdBy: string | null
          icon: Database["public"]["Enums"]["iconName"] | null
          id: string
          name: string
          orgId: string
          ranking: number
          state: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId: string | null
        }
        Insert: {
          color: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name: string
          orgId?: string
          ranking: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name?: string
          orgId?: string
          ranking?: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contact_member_authorization_types_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_member_authorization_types_dHHkYgZbOmb2_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_member_authorization_types_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      contactMembers: {
        Row: {
          contactId: string | null
          contactMemberTypeId: string | null
          createdAt: string | null
          createdBy: string | null
          email: string | null
          firstName: string | null
          fullName: string | null
          id: string
          lastName: string | null
          orgId: string
          phone: string | null
          title: Database["public"]["Enums"]["personTitle"] | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          contactId?: string | null
          contactMemberTypeId?: string | null
          createdAt?: string | null
          createdBy?: string | null
          email?: string | null
          firstName?: string | null
          fullName?: string | null
          id?: string
          lastName?: string | null
          orgId?: string
          phone?: string | null
          title?: Database["public"]["Enums"]["personTitle"] | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          contactId?: string | null
          contactMemberTypeId?: string | null
          createdAt?: string | null
          createdBy?: string | null
          email?: string | null
          firstName?: string | null
          fullName?: string | null
          id?: string
          lastName?: string | null
          orgId?: string
          phone?: string | null
          title?: Database["public"]["Enums"]["personTitle"] | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contact_members_contact_id_contacts_id_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_members_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_members_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_members_v4aMRmKhhAW9_fkey"
            columns: ["contactMemberTypeId"]
            isOneToOne: false
            referencedRelation: "contactMemberTypes"
            referencedColumns: ["id"]
          },
        ]
      }
      contactMemberTypes: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string
          createdBy: string | null
          icon: Database["public"]["Enums"]["iconName"] | null
          id: string
          name: string
          orgId: string
          ranking: number
          state: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId: string | null
        }
        Insert: {
          color: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name: string
          orgId?: string
          ranking: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name?: string
          orgId?: string
          ranking?: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contact_member_types_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_member_types_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_member_types_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      contactNotes: {
        Row: {
          contactId: string
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
        }
        Insert: {
          contactId: string
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
        }
        Update: {
          contactId?: string
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "contact_notes_contact_id_contacts_id_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      contacts: {
        Row: {
          city: string | null
          contactTypeId: string | null
          createdAt: string
          createdBy: string | null
          email: string | null
          fax: string | null
          houseNumber: string | null
          id: string
          name: string
          orgId: string
          phone: string | null
          relatedContactId: string | null
          state: Database["public"]["Enums"]["state"]
          streetName: string | null
          taxNumber: string | null
          updatedAt: string | null
          updatedBy: string | null
          vatId: string | null
          workspaceId: string | null
          zipCode: string | null
        }
        Insert: {
          city?: string | null
          contactTypeId?: string | null
          createdAt?: string
          createdBy?: string | null
          email?: string | null
          fax?: string | null
          houseNumber?: string | null
          id?: string
          name: string
          orgId?: string
          phone?: string | null
          relatedContactId?: string | null
          state?: Database["public"]["Enums"]["state"]
          streetName?: string | null
          taxNumber?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          vatId?: string | null
          workspaceId?: string | null
          zipCode?: string | null
        }
        Update: {
          city?: string | null
          contactTypeId?: string | null
          createdAt?: string
          createdBy?: string | null
          email?: string | null
          fax?: string | null
          houseNumber?: string | null
          id?: string
          name?: string
          orgId?: string
          phone?: string | null
          relatedContactId?: string | null
          state?: Database["public"]["Enums"]["state"]
          streetName?: string | null
          taxNumber?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          vatId?: string | null
          workspaceId?: string | null
          zipCode?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contacts_contact_type_id_contact_types_id_fkey"
            columns: ["contactTypeId"]
            isOneToOne: false
            referencedRelation: "contactTypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contacts_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contacts_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contacts_related_contact_id_fkey"
            columns: ["relatedContactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contacts_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contacts_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      contactTypes: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string
          createdBy: string | null
          icon: Database["public"]["Enums"]["iconName"] | null
          id: string
          name: string
          orgId: string
          ranking: number
          state: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId: string | null
        }
        Insert: {
          color: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name: string
          orgId?: string
          ranking: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name?: string
          orgId?: string
          ranking?: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "contact_types_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_types_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "contact_types_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      costCenters: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string
          createdBy: string | null
          id: string
          isActive: boolean
          name: string
          number: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          id?: string
          isActive?: boolean
          name: string
          number: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          id?: string
          isActive?: boolean
          name?: string
          number?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "cost_centers_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "cost_centers_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "cost_centers_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      crewDefinitionManagerSlots: {
        Row: {
          createdAt: string
          createdBy: string | null
          crewDefinitionId: string
          endDate: string | null
          id: string
          orgId: string
          startDate: string
          userId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          crewDefinitionId: string
          endDate?: string | null
          id?: string
          orgId?: string
          startDate: string
          userId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          crewDefinitionId?: string
          endDate?: string | null
          id?: string
          orgId?: string
          startDate?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "crew_definition_manager_slots_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_manager_slots_IPkkJOrG8mI0_fkey"
            columns: ["crewDefinitionId"]
            isOneToOne: false
            referencedRelation: "crewDefinitions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_manager_slots_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_manager_slots_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      crewDefinitionMembers: {
        Row: {
          crewDefinitionId: string
          id: string
          isLead: boolean
          orgId: string
          userId: string
        }
        Insert: {
          crewDefinitionId: string
          id?: string
          isLead?: boolean
          orgId?: string
          userId: string
        }
        Update: {
          crewDefinitionId?: string
          id?: string
          isLead?: boolean
          orgId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "crew_definition_members_jqK5rW76ow5y_fkey"
            columns: ["crewDefinitionId"]
            isOneToOne: false
            referencedRelation: "crewDefinitions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_members_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      crewDefinitions: {
        Row: {
          createdAt: string
          createdBy: string | null
          endDate: string | null
          id: string
          name: string | null
          orgId: string
          partnerOrgId: string | null
          startDate: string
          vehicleId: string | null
          weekdays: number[]
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          endDate?: string | null
          id?: string
          name?: string | null
          orgId?: string
          partnerOrgId?: string | null
          startDate: string
          vehicleId?: string | null
          weekdays?: number[]
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          endDate?: string | null
          id?: string
          name?: string | null
          orgId?: string
          partnerOrgId?: string | null
          startDate?: string
          vehicleId?: string | null
          weekdays?: number[]
        }
        Relationships: [
          {
            foreignKeyName: "crew_definitions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definitions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definitions_partner_org_id_organizations_id_fkey"
            columns: ["partnerOrgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definitions_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      crewDefinitionTicketAssignments: {
        Row: {
          createdAt: string
          createdBy: string | null
          crewDefinitionId: string
          endDate: string
          id: string
          orgId: string
          startDate: string
          ticketId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          crewDefinitionId: string
          endDate: string
          id?: string
          orgId?: string
          startDate: string
          ticketId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          crewDefinitionId?: string
          endDate?: string
          id?: string
          orgId?: string
          startDate?: string
          ticketId?: string
        }
        Relationships: [
          {
            foreignKeyName: "crew_definition_ticket_assignments_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_ticket_assignments_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_ticket_assignments_ticket_id_tickets_id_fkey"
            columns: ["ticketId"]
            isOneToOne: false
            referencedRelation: "tickets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crew_definition_ticket_assignments_UHtRf2kOx8Mo_fkey"
            columns: ["crewDefinitionId"]
            isOneToOne: false
            referencedRelation: "crewDefinitions"
            referencedColumns: ["id"]
          },
        ]
      }
      crews: {
        Row: {
          createdAt: string
          createdBy: string | null
          crewDefinitionId: string | null
          id: string
          orgId: string | null
          planId: string
          planOrgId: string
          ranking: number
          workspaceId: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          crewDefinitionId?: string | null
          id?: string
          orgId?: string | null
          planId: string
          planOrgId?: string
          ranking: number
          workspaceId?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          crewDefinitionId?: string | null
          id?: string
          orgId?: string | null
          planId?: string
          planOrgId?: string
          ranking?: number
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "crews_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crews_crew_definition_id_crew_definitions_id_fkey"
            columns: ["crewDefinitionId"]
            isOneToOne: false
            referencedRelation: "crewDefinitions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crews_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crews_plan_id_plans_id_fkey"
            columns: ["planId"]
            isOneToOne: false
            referencedRelation: "plans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crews_plan_org_id_organizations_id_fkey"
            columns: ["planOrgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "crews_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      emailPreferences: {
        Row: {
          email: string
          emailType: Database["public"]["Enums"]["emailType"] | null
          id: string
          orgId: string
          type: Database["public"]["Enums"]["emailPreferencesType"]
          value: string | null
        }
        Insert: {
          email: string
          emailType?: Database["public"]["Enums"]["emailType"] | null
          id?: string
          orgId: string
          type: Database["public"]["Enums"]["emailPreferencesType"]
          value?: string | null
        }
        Update: {
          email?: string
          emailType?: Database["public"]["Enums"]["emailType"] | null
          id?: string
          orgId?: string
          type?: Database["public"]["Enums"]["emailPreferencesType"]
          value?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "email_preferences_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      employments: {
        Row: {
          createdAt: string
          createdBy: string | null
          hoursPerWeek: number
          id: string
          jobTitle: string
          orgId: string
          region: Database["public"]["Enums"]["region"]
          updatedAt: string | null
          updatedBy: string | null
          userId: string
          vacationDays: number
          vacationDaysAccrualType: Database["public"]["Enums"]["vacationDaysAccrualType"]
          validFrom: string
          validTo: string | null
          workdays: number[]
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          hoursPerWeek?: number
          id?: string
          jobTitle: string
          orgId?: string
          region?: Database["public"]["Enums"]["region"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId: string
          vacationDays?: number
          vacationDaysAccrualType?: Database["public"]["Enums"]["vacationDaysAccrualType"]
          validFrom: string
          validTo?: string | null
          workdays?: number[]
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          hoursPerWeek?: number
          id?: string
          jobTitle?: string
          orgId?: string
          region?: Database["public"]["Enums"]["region"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
          vacationDays?: number
          vacationDaysAccrualType?: Database["public"]["Enums"]["vacationDaysAccrualType"]
          validFrom?: string
          validTo?: string | null
          workdays?: number[]
        }
        Relationships: [
          {
            foreignKeyName: "employments_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "employments_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "employments_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "employments_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      fileAnnotations: {
        Row: {
          annotations: Json | null
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          annotations?: Json | null
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          annotations?: Json | null
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "file_annotations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_annotations_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: true
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_annotations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_annotations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      fileClassifications: {
        Row: {
          batchId: string
          candidates: Json | null
          confidence: number | null
          createdAt: string
          createdBy: string | null
          documentKind: Database["public"]["Enums"]["documentKind"] | null
          error: string | null
          fileId: string
          id: string
          orgId: string
          reason: string | null
          state: Database["public"]["Enums"]["fileClassificationState"]
          targetKeys: Json | null
          targetTable: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          batchId: string
          candidates?: Json | null
          confidence?: number | null
          createdAt?: string
          createdBy?: string | null
          documentKind?: Database["public"]["Enums"]["documentKind"] | null
          error?: string | null
          fileId: string
          id?: string
          orgId?: string
          reason?: string | null
          state?: Database["public"]["Enums"]["fileClassificationState"]
          targetKeys?: Json | null
          targetTable?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          batchId?: string
          candidates?: Json | null
          confidence?: number | null
          createdAt?: string
          createdBy?: string | null
          documentKind?: Database["public"]["Enums"]["documentKind"] | null
          error?: string | null
          fileId?: string
          id?: string
          orgId?: string
          reason?: string | null
          state?: Database["public"]["Enums"]["fileClassificationState"]
          targetKeys?: Json | null
          targetTable?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "file_classifications_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_classifications_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: true
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_classifications_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_classifications_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      fileContents: {
        Row: {
          chunks: Json | null
          content: string | null
          detectedLanguages: string | null
          extractedServices: Json | null
          fileId: string
          id: string
          metadata: Json | null
          orgId: string
          pages: number | null
          tables: Json | null
        }
        Insert: {
          chunks?: Json | null
          content?: string | null
          detectedLanguages?: string | null
          extractedServices?: Json | null
          fileId: string
          id?: string
          metadata?: Json | null
          orgId?: string
          pages?: number | null
          tables?: Json | null
        }
        Update: {
          chunks?: Json | null
          content?: string | null
          detectedLanguages?: string | null
          extractedServices?: Json | null
          fileId?: string
          id?: string
          metadata?: Json | null
          orgId?: string
          pages?: number | null
          tables?: Json | null
        }
        Relationships: [
          {
            foreignKeyName: "file_contents_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "file_contents_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      files: {
        Row: {
          contentType: string
          createdAt: string
          createdBy: string | null
          directory: string
          fileName: string
          fullPath: string
          height: number | null
          id: string
          orgId: string
          pathPrefix: string
          size: number
          updatedAt: string | null
          updatedBy: string | null
          width: number | null
        }
        Insert: {
          contentType: string
          createdAt?: string
          createdBy?: string | null
          directory: string
          fileName: string
          fullPath: string
          height?: number | null
          id?: string
          orgId?: string
          pathPrefix: string
          size?: number
          updatedAt?: string | null
          updatedBy?: string | null
          width?: number | null
        }
        Update: {
          contentType?: string
          createdAt?: string
          createdBy?: string | null
          directory?: string
          fileName?: string
          fullPath?: string
          height?: number | null
          id?: string
          orgId?: string
          pathPrefix?: string
          size?: number
          updatedAt?: string | null
          updatedBy?: string | null
          width?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingEmailFiles: {
        Row: {
          contentSha256: string | null
          contentType: string
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          incomingEmailId: string
          invoiceCheckReason: string | null
          invoiceCheckState: Database["public"]["Enums"]["incomingEmailFileInvoiceCheckState"]
          invoiceConfidence: number | null
          invoiceKind:
            | Database["public"]["Enums"]["incomingEmailFileInvoiceKind"]
            | null
          isInvoice: boolean | null
          orgId: string
          originalFileName: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          contentSha256?: string | null
          contentType: string
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          incomingEmailId: string
          invoiceCheckReason?: string | null
          invoiceCheckState?: Database["public"]["Enums"]["incomingEmailFileInvoiceCheckState"]
          invoiceConfidence?: number | null
          invoiceKind?:
            | Database["public"]["Enums"]["incomingEmailFileInvoiceKind"]
            | null
          isInvoice?: boolean | null
          orgId?: string
          originalFileName: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          contentSha256?: string | null
          contentType?: string
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          incomingEmailId?: string
          invoiceCheckReason?: string | null
          invoiceCheckState?: Database["public"]["Enums"]["incomingEmailFileInvoiceCheckState"]
          invoiceConfidence?: number | null
          invoiceKind?:
            | Database["public"]["Enums"]["incomingEmailFileInvoiceKind"]
            | null
          isInvoice?: boolean | null
          orgId?: string
          originalFileName?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_email_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_email_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: true
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_email_files_incoming_email_id_incoming_emails_id_fkey"
            columns: ["incomingEmailId"]
            isOneToOne: false
            referencedRelation: "incomingEmails"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_email_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_email_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingEmails: {
        Row: {
          attachmentCount: number
          bodyText: string | null
          ccAddresses: string[]
          createdAt: string
          createdBy: string | null
          externalId: string
          fromAddress: string | null
          fromName: string | null
          id: string
          inReplyTo: string | null
          mailboxId: string | null
          messageId: string | null
          note: string | null
          orgId: string
          outcome: Database["public"]["Enums"]["incomingEmailOutcome"]
          processingError: string | null
          processingState: Database["public"]["Enums"]["incomingEmailProcessingState"]
          purpose: Database["public"]["Enums"]["mailboxPurpose"]
          rawPath: string | null
          receivedAt: string
          sentAt: string | null
          size: number
          subject: string | null
          toAddresses: string[]
        }
        Insert: {
          attachmentCount?: number
          bodyText?: string | null
          ccAddresses?: string[]
          createdAt?: string
          createdBy?: string | null
          externalId: string
          fromAddress?: string | null
          fromName?: string | null
          id?: string
          inReplyTo?: string | null
          mailboxId?: string | null
          messageId?: string | null
          note?: string | null
          orgId?: string
          outcome: Database["public"]["Enums"]["incomingEmailOutcome"]
          processingError?: string | null
          processingState?: Database["public"]["Enums"]["incomingEmailProcessingState"]
          purpose: Database["public"]["Enums"]["mailboxPurpose"]
          rawPath?: string | null
          receivedAt: string
          sentAt?: string | null
          size?: number
          subject?: string | null
          toAddresses?: string[]
        }
        Update: {
          attachmentCount?: number
          bodyText?: string | null
          ccAddresses?: string[]
          createdAt?: string
          createdBy?: string | null
          externalId?: string
          fromAddress?: string | null
          fromName?: string | null
          id?: string
          inReplyTo?: string | null
          mailboxId?: string | null
          messageId?: string | null
          note?: string | null
          orgId?: string
          outcome?: Database["public"]["Enums"]["incomingEmailOutcome"]
          processingError?: string | null
          processingState?: Database["public"]["Enums"]["incomingEmailProcessingState"]
          purpose?: Database["public"]["Enums"]["mailboxPurpose"]
          rawPath?: string | null
          receivedAt?: string
          sentAt?: string | null
          size?: number
          subject?: string | null
          toAddresses?: string[]
        }
        Relationships: [
          {
            foreignKeyName: "incoming_emails_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_emails_mailbox_id_organization_mailboxes_id_fkey"
            columns: ["mailboxId"]
            isOneToOne: false
            referencedRelation: "organizationMailboxes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_emails_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceApprovalDecisions: {
        Row: {
          approvalId: string | null
          comment: string | null
          costAllocation: Json | null
          createdAt: string
          createdBy: string | null
          id: string
          incomingInvoiceId: string
          orgId: string
          reducedNetAmount: number | null
          reductionReason: string | null
          state: Database["public"]["Enums"]["incomingInvoiceApprovalState"]
          userId: string | null
        }
        Insert: {
          approvalId?: string | null
          comment?: string | null
          costAllocation?: Json | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId: string
          orgId?: string
          reducedNetAmount?: number | null
          reductionReason?: string | null
          state: Database["public"]["Enums"]["incomingInvoiceApprovalState"]
          userId?: string | null
        }
        Update: {
          approvalId?: string | null
          comment?: string | null
          costAllocation?: Json | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          reducedNetAmount?: number | null
          reductionReason?: string | null
          state?: Database["public"]["Enums"]["incomingInvoiceApprovalState"]
          userId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_approval_decisions_41X47akAcW3W_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approval_decisions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approval_decisions_h6Mq3l9qd13K_fkey"
            columns: ["approvalId"]
            isOneToOne: false
            referencedRelation: "incomingInvoiceApprovals"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approval_decisions_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approval_decisions_xNwMbL6mp3XB_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceApprovals: {
        Row: {
          assignedBy: string | null
          assignment: Database["public"]["Enums"]["incomingInvoiceApprovalAssignment"]
          chainPosition: number
          comment: string | null
          createdAt: string
          createdBy: string | null
          decidedAt: string | null
          id: string
          incomingInvoiceId: string
          isSoleApprover: boolean
          orgId: string
          state: Database["public"]["Enums"]["incomingInvoiceApprovalState"]
          userId: string
        }
        Insert: {
          assignedBy?: string | null
          assignment?: Database["public"]["Enums"]["incomingInvoiceApprovalAssignment"]
          chainPosition?: number
          comment?: string | null
          createdAt?: string
          createdBy?: string | null
          decidedAt?: string | null
          id?: string
          incomingInvoiceId: string
          isSoleApprover?: boolean
          orgId?: string
          state?: Database["public"]["Enums"]["incomingInvoiceApprovalState"]
          userId: string
        }
        Update: {
          assignedBy?: string | null
          assignment?: Database["public"]["Enums"]["incomingInvoiceApprovalAssignment"]
          chainPosition?: number
          comment?: string | null
          createdAt?: string
          createdBy?: string | null
          decidedAt?: string | null
          id?: string
          incomingInvoiceId?: string
          isSoleApprover?: boolean
          orgId?: string
          state?: Database["public"]["Enums"]["incomingInvoiceApprovalState"]
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_approvals_assigned_by_users_id_fkey"
            columns: ["assignedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approvals_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approvals_diDcjrsO8P4y_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approvals_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_approvals_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceChecks: {
        Row: {
          checkedAt: string
          checkKey: string
          createdAt: string
          createdBy: string | null
          details: Json | null
          id: string
          incomingInvoiceId: string
          orgId: string
          state: Database["public"]["Enums"]["incomingInvoiceCheckState"]
        }
        Insert: {
          checkedAt?: string
          checkKey: string
          createdAt?: string
          createdBy?: string | null
          details?: Json | null
          id?: string
          incomingInvoiceId: string
          orgId?: string
          state: Database["public"]["Enums"]["incomingInvoiceCheckState"]
        }
        Update: {
          checkedAt?: string
          checkKey?: string
          createdAt?: string
          createdBy?: string | null
          details?: Json | null
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          state?: Database["public"]["Enums"]["incomingInvoiceCheckState"]
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_checks_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_checks_N7nuh7FQIfU3_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_checks_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceCostAllocations: {
        Row: {
          amount: number
          costCenterId: string
          createdAt: string
          createdBy: string | null
          id: string
          incomingInvoiceId: string
          orgId: string
          source: Database["public"]["Enums"]["incomingInvoiceCostAllocationSource"]
        }
        Insert: {
          amount: number
          costCenterId: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId: string
          orgId?: string
          source: Database["public"]["Enums"]["incomingInvoiceCostAllocationSource"]
        }
        Update: {
          amount?: number
          costCenterId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          source?: Database["public"]["Enums"]["incomingInvoiceCostAllocationSource"]
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_cost_allocations_boveSe6y3Fk7_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_cost_allocations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_cost_allocations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_cost_allocations_rkaMeBf4RRM1_fkey"
            columns: ["costCenterId"]
            isOneToOne: false
            referencedRelation: "costCenters"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceDefaultApprovers: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          userId: string
          workspaceId: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          userId: string
          workspaceId?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          userId?: string
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_default_approvers_0zJleNEXiRUy_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_default_approvers_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_default_approvers_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_default_approvers_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceDeliveryNotePositions: {
        Row: {
          createdAt: string
          createdBy: string | null
          deliveryNoteId: string
          description: string
          id: string
          orgId: string
          positionNumber: string | null
          quantity: number | null
          ranking: number
          unit: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          deliveryNoteId: string
          description: string
          id?: string
          orgId?: string
          positionNumber?: string | null
          quantity?: number | null
          ranking: number
          unit?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          deliveryNoteId?: string
          description?: string
          id?: string
          orgId?: string
          positionNumber?: string | null
          quantity?: number | null
          ranking?: number
          unit?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_delivery_note_positions_68ukDDGzJgAr_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_delivery_note_positions_Q22PVD5rgAnd_fkey"
            columns: ["deliveryNoteId"]
            isOneToOne: false
            referencedRelation: "incomingInvoiceDeliveryNotes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_delivery_note_positions_XCpDHloumsgH_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceDeliveryNotes: {
        Row: {
          createdAt: string
          createdBy: string | null
          deliveryDate: string | null
          extractionError: string | null
          extractionState:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          id: string
          incomingEmailFileId: string | null
          incomingInvoiceId: string | null
          issuerName: string | null
          issuerVatId: string | null
          number: string | null
          orderReference: string | null
          orgId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          deliveryDate?: string | null
          extractionError?: string | null
          extractionState?:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          id?: string
          incomingEmailFileId?: string | null
          incomingInvoiceId?: string | null
          issuerName?: string | null
          issuerVatId?: string | null
          number?: string | null
          orderReference?: string | null
          orgId?: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          deliveryDate?: string | null
          extractionError?: string | null
          extractionState?:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          id?: string
          incomingEmailFileId?: string | null
          incomingInvoiceId?: string | null
          issuerName?: string | null
          issuerVatId?: string | null
          number?: string | null
          orderReference?: string | null
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_delivery_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_delivery_notes_fkb97ZnQ83XA_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_delivery_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_delivery_notes_oRzovqzEGs8a_fkey"
            columns: ["incomingEmailFileId"]
            isOneToOne: true
            referencedRelation: "incomingEmailFiles"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceEvents: {
        Row: {
          actorId: string | null
          id: string
          incomingInvoiceId: string
          occurredAt: string
          orgId: string
          payload: Json
          sequence: number
          type: Database["public"]["Enums"]["incomingInvoiceEventType"]
        }
        Insert: {
          actorId?: string | null
          id?: string
          incomingInvoiceId: string
          occurredAt?: string
          orgId?: string
          payload?: Json
          sequence?: never
          type: Database["public"]["Enums"]["incomingInvoiceEventType"]
        }
        Update: {
          actorId?: string | null
          id?: string
          incomingInvoiceId?: string
          occurredAt?: string
          orgId?: string
          payload?: Json
          sequence?: never
          type?: Database["public"]["Enums"]["incomingInvoiceEventType"]
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_events_1tfBFtlE9AKP_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_events_actor_id_users_id_fkey"
            columns: ["actorId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_events_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          incomingInvoiceId: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          incomingInvoiceId: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_files_JP8bDUinxVc1_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          incomingInvoiceId: string
          noteId: string
          orgId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          incomingInvoiceId: string
          noteId: string
          orgId?: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          incomingInvoiceId?: string
          noteId?: string
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_notes_I2oReG3u2qLx_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceOffsets: {
        Row: {
          amount: number
          createdAt: string
          createdBy: string | null
          id: string
          incomingInvoiceId: string
          orgId: string
          outgoingInvoiceId: string
          paymentId: string
          revertedAt: string | null
        }
        Insert: {
          amount: number
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId: string
          orgId?: string
          outgoingInvoiceId: string
          paymentId: string
          revertedAt?: string | null
        }
        Update: {
          amount?: number
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          outgoingInvoiceId?: string
          paymentId?: string
          revertedAt?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_offsets_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_offsets_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_offsets_P5DZK3H2S0Uv_fkey"
            columns: ["paymentId"]
            isOneToOne: false
            referencedRelation: "incomingInvoicePayments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_offsets_QSGVShgKhwXW_fkey"
            columns: ["outgoingInvoiceId"]
            isOneToOne: false
            referencedRelation: "outgoingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_offsets_v1Z2q71VDF9W_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoicePaymentRuns: {
        Row: {
          controlSum: number
          createdAt: string
          createdBy: string | null
          document: string
          executionDate: string
          format: Database["public"]["Enums"]["incomingInvoicePaymentFormat"]
          id: string
          isSkontoApplied: boolean
          messageId: string
          orgId: string
          transactionCount: number
        }
        Insert: {
          controlSum: number
          createdAt?: string
          createdBy?: string | null
          document: string
          executionDate: string
          format: Database["public"]["Enums"]["incomingInvoicePaymentFormat"]
          id?: string
          isSkontoApplied: boolean
          messageId: string
          orgId?: string
          transactionCount: number
        }
        Update: {
          controlSum?: number
          createdAt?: string
          createdBy?: string | null
          document?: string
          executionDate?: string
          format?: Database["public"]["Enums"]["incomingInvoicePaymentFormat"]
          id?: string
          isSkontoApplied?: boolean
          messageId?: string
          orgId?: string
          transactionCount?: number
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_payment_runs_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_payment_runs_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoicePayments: {
        Row: {
          amount: number
          createdAt: string
          createdBy: string | null
          creditorIban: string
          currency: string
          debtorIban: string
          endToEndId: string
          id: string
          incomingInvoiceId: string
          orgId: string
          paymentRunId: string
          revertedAt: string | null
          revertedBy: string | null
          skontoAmount: number | null
        }
        Insert: {
          amount: number
          createdAt?: string
          createdBy?: string | null
          creditorIban: string
          currency?: string
          debtorIban: string
          endToEndId: string
          id?: string
          incomingInvoiceId: string
          orgId?: string
          paymentRunId: string
          revertedAt?: string | null
          revertedBy?: string | null
          skontoAmount?: number | null
        }
        Update: {
          amount?: number
          createdAt?: string
          createdBy?: string | null
          creditorIban?: string
          currency?: string
          debtorIban?: string
          endToEndId?: string
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          paymentRunId?: string
          revertedAt?: string | null
          revertedBy?: string | null
          skontoAmount?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_payments_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_payments_j6EMF2BTZj7J_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_payments_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_payments_PD72CiGpWCVs_fkey"
            columns: ["paymentRunId"]
            isOneToOne: false
            referencedRelation: "incomingInvoicePaymentRuns"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_payments_reverted_by_users_id_fkey"
            columns: ["revertedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoicePlannedOffsets: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          incomingInvoiceId: string
          orgId: string
          outgoingInvoiceId: string
          position: number
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId: string
          orgId?: string
          outgoingInvoiceId: string
          position: number
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          outgoingInvoiceId?: string
          position?: number
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_planned_offsets_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_planned_offsets_I4qHQrNV0njP_fkey"
            columns: ["outgoingInvoiceId"]
            isOneToOne: false
            referencedRelation: "outgoingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_planned_offsets_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_planned_offsets_tDIpgIlWXwJP_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoicePositions: {
        Row: {
          createdAt: string
          createdBy: string | null
          description: string
          id: string
          incomingInvoiceId: string
          orgId: string
          positionNumber: string | null
          quantity: number | null
          ranking: number
          total: number | null
          unit: string | null
          unitPrice: number | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          description: string
          id?: string
          incomingInvoiceId: string
          orgId?: string
          positionNumber?: string | null
          quantity?: number | null
          ranking: number
          total?: number | null
          unit?: string | null
          unitPrice?: number | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          description?: string
          id?: string
          incomingInvoiceId?: string
          orgId?: string
          positionNumber?: string | null
          quantity?: number | null
          ranking?: number
          total?: number | null
          unit?: string | null
          unitPrice?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_positions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_positions_O0Syv2AO5U8a_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_positions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoiceReminders: {
        Row: {
          amountDue: number | null
          createdAt: string
          createdBy: string | null
          currency: string
          dueDate: string | null
          extractionError: string | null
          extractionState:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          fee: number | null
          id: string
          incomingEmailFileId: string | null
          incomingInvoiceId: string | null
          issuerName: string | null
          issuerVatId: string | null
          level: number | null
          orgId: string
          referencedInvoiceNumber: string | null
          reminderDate: string | null
        }
        Insert: {
          amountDue?: number | null
          createdAt?: string
          createdBy?: string | null
          currency?: string
          dueDate?: string | null
          extractionError?: string | null
          extractionState?:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          fee?: number | null
          id?: string
          incomingEmailFileId?: string | null
          incomingInvoiceId?: string | null
          issuerName?: string | null
          issuerVatId?: string | null
          level?: number | null
          orgId?: string
          referencedInvoiceNumber?: string | null
          reminderDate?: string | null
        }
        Update: {
          amountDue?: number | null
          createdAt?: string
          createdBy?: string | null
          currency?: string
          dueDate?: string | null
          extractionError?: string | null
          extractionState?:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          fee?: number | null
          id?: string
          incomingEmailFileId?: string | null
          incomingInvoiceId?: string | null
          issuerName?: string | null
          issuerVatId?: string | null
          level?: number | null
          orgId?: string
          referencedInvoiceNumber?: string | null
          reminderDate?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoice_reminders_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_reminders_OLMDkBwj2fMf_fkey"
            columns: ["incomingEmailFileId"]
            isOneToOne: true
            referencedRelation: "incomingEmailFiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_reminders_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoice_reminders_TPf4hLkI8r59_fkey"
            columns: ["incomingInvoiceId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
        ]
      }
      incomingInvoices: {
        Row: {
          bic: string | null
          contactId: string | null
          createdAt: string
          createdBy: string | null
          currency: string
          deliveryNoteNumbers: string[]
          dueDate: string | null
          duplicateOfId: string | null
          eInvoiceFormat:
            | Database["public"]["Enums"]["incomingInvoiceEInvoiceFormat"]
            | null
          extractionError: string | null
          extractionState:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          grossAmount: number | null
          iban: string | null
          id: string
          incomingEmailFileId: string | null
          invoiceDate: string | null
          isDuplicateDismissed: boolean
          issuerCity: string | null
          issuerCountry: string | null
          issuerEmail: string | null
          issuerHouseNumber: string | null
          issuerName: string | null
          issuerPhone: string | null
          issuerStreet: string | null
          issuerTaxNumber: string | null
          issuerVatId: string | null
          issuerZipCode: string | null
          kind: Database["public"]["Enums"]["incomingInvoiceKind"]
          netAmount: number | null
          note: string | null
          number: string | null
          orderReference: string | null
          orgId: string
          partnerReportId: string | null
          projectId: string | null
          receivedAt: string | null
          recipientCity: string | null
          recipientHouseNumber: string | null
          recipientName: string | null
          recipientStreet: string | null
          recipientZipCode: string | null
          reducedNetAmount: number | null
          reductionReason: string | null
          reportNumber: string | null
          skontoAmount: number | null
          skontoDeadline: string | null
          skontoRate: number | null
          state: Database["public"]["Enums"]["incomingInvoiceState"]
          updatedAt: string | null
          updatedBy: string | null
          vatAmount: number | null
          vatRate: number | null
          workspaceId: string | null
        }
        Insert: {
          bic?: string | null
          contactId?: string | null
          createdAt?: string
          createdBy?: string | null
          currency?: string
          deliveryNoteNumbers?: string[]
          dueDate?: string | null
          duplicateOfId?: string | null
          eInvoiceFormat?:
            | Database["public"]["Enums"]["incomingInvoiceEInvoiceFormat"]
            | null
          extractionError?: string | null
          extractionState?:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          grossAmount?: number | null
          iban?: string | null
          id?: string
          incomingEmailFileId?: string | null
          invoiceDate?: string | null
          isDuplicateDismissed?: boolean
          issuerCity?: string | null
          issuerCountry?: string | null
          issuerEmail?: string | null
          issuerHouseNumber?: string | null
          issuerName?: string | null
          issuerPhone?: string | null
          issuerStreet?: string | null
          issuerTaxNumber?: string | null
          issuerVatId?: string | null
          issuerZipCode?: string | null
          kind?: Database["public"]["Enums"]["incomingInvoiceKind"]
          netAmount?: number | null
          note?: string | null
          number?: string | null
          orderReference?: string | null
          orgId?: string
          partnerReportId?: string | null
          projectId?: string | null
          receivedAt?: string | null
          recipientCity?: string | null
          recipientHouseNumber?: string | null
          recipientName?: string | null
          recipientStreet?: string | null
          recipientZipCode?: string | null
          reducedNetAmount?: number | null
          reductionReason?: string | null
          reportNumber?: string | null
          skontoAmount?: number | null
          skontoDeadline?: string | null
          skontoRate?: number | null
          state?: Database["public"]["Enums"]["incomingInvoiceState"]
          updatedAt?: string | null
          updatedBy?: string | null
          vatAmount?: number | null
          vatRate?: number | null
          workspaceId?: string | null
        }
        Update: {
          bic?: string | null
          contactId?: string | null
          createdAt?: string
          createdBy?: string | null
          currency?: string
          deliveryNoteNumbers?: string[]
          dueDate?: string | null
          duplicateOfId?: string | null
          eInvoiceFormat?:
            | Database["public"]["Enums"]["incomingInvoiceEInvoiceFormat"]
            | null
          extractionError?: string | null
          extractionState?:
            | Database["public"]["Enums"]["incomingInvoiceExtractionState"]
            | null
          grossAmount?: number | null
          iban?: string | null
          id?: string
          incomingEmailFileId?: string | null
          invoiceDate?: string | null
          isDuplicateDismissed?: boolean
          issuerCity?: string | null
          issuerCountry?: string | null
          issuerEmail?: string | null
          issuerHouseNumber?: string | null
          issuerName?: string | null
          issuerPhone?: string | null
          issuerStreet?: string | null
          issuerTaxNumber?: string | null
          issuerVatId?: string | null
          issuerZipCode?: string | null
          kind?: Database["public"]["Enums"]["incomingInvoiceKind"]
          netAmount?: number | null
          note?: string | null
          number?: string | null
          orderReference?: string | null
          orgId?: string
          partnerReportId?: string | null
          projectId?: string | null
          receivedAt?: string | null
          recipientCity?: string | null
          recipientHouseNumber?: string | null
          recipientName?: string | null
          recipientStreet?: string | null
          recipientZipCode?: string | null
          reducedNetAmount?: number | null
          reductionReason?: string | null
          reportNumber?: string | null
          skontoAmount?: number | null
          skontoDeadline?: string | null
          skontoRate?: number | null
          state?: Database["public"]["Enums"]["incomingInvoiceState"]
          updatedAt?: string | null
          updatedBy?: string | null
          vatAmount?: number | null
          vatRate?: number | null
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "incoming_invoices_contact_id_contacts_id_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_duplicate_of_id_incoming_invoices_id_fkey"
            columns: ["duplicateOfId"]
            isOneToOne: false
            referencedRelation: "incomingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_onzPw7laVgaa_fkey"
            columns: ["incomingEmailFileId"]
            isOneToOne: true
            referencedRelation: "incomingEmailFiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_partner_report_id_partner_reports_id_fkey"
            columns: ["partnerReportId"]
            isOneToOne: false
            referencedRelation: "partnerReports"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incoming_invoices_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      jwks: {
        Row: {
          createdAt: string
          id: string
          privateKey: string
          publicKey: string
        }
        Insert: {
          createdAt: string
          id: string
          privateKey: string
          publicKey: string
        }
        Update: {
          createdAt?: string
          id?: string
          privateKey?: string
          publicKey?: string
        }
        Relationships: []
      }
      loadCarriers: {
        Row: {
          createdAt: string
          createdBy: string | null
          depth: number | null
          description: string | null
          height: number | null
          homeZoneId: string | null
          id: string
          minimumStockBalance: number
          name: string
          orgId: string
          sizeUnit: Database["public"]["Enums"]["unit"] | null
          updatedAt: string | null
          updatedBy: string | null
          warningStockBalance: number
          weight: number | null
          weightUnit: Database["public"]["Enums"]["unit"] | null
          width: number | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          depth?: number | null
          description?: string | null
          height?: number | null
          homeZoneId?: string | null
          id?: string
          minimumStockBalance?: number
          name: string
          orgId?: string
          sizeUnit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
          warningStockBalance?: number
          weight?: number | null
          weightUnit?: Database["public"]["Enums"]["unit"] | null
          width?: number | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          depth?: number | null
          description?: string | null
          height?: number | null
          homeZoneId?: string | null
          id?: string
          minimumStockBalance?: number
          name?: string
          orgId?: string
          sizeUnit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
          warningStockBalance?: number
          weight?: number | null
          weightUnit?: Database["public"]["Enums"]["unit"] | null
          width?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "load_carriers_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carriers_home_zone_id_warehouse_zones_id_fkey"
            columns: ["homeZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carriers_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carriers_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      loadCarrierStockBalances: {
        Row: {
          id: string
          loadCarrierId: string
          orgId: string
          quantity: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          id?: string
          loadCarrierId: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          id?: string
          loadCarrierId?: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "load_carrier_stock_balances_3eQbzSIFvfVR_fkey"
            columns: ["loadCarrierId"]
            isOneToOne: true
            referencedRelation: "loadCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_balances_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_balances_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      loadCarrierStockTransactions: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          loadCarrierId: string
          operation: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId: string
          quantity: number
          returnOrderId: string | null
          suborderId: string | null
          type: Database["public"]["Enums"]["transactionType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          loadCarrierId: string
          operation: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId?: string
          quantity: number
          returnOrderId?: string | null
          suborderId?: string | null
          type: Database["public"]["Enums"]["transactionType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          loadCarrierId?: string
          operation?: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId?: string
          quantity?: number
          returnOrderId?: string | null
          suborderId?: string | null
          type?: Database["public"]["Enums"]["transactionType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "load_carrier_stock_transactions_bUG8nZtAvIOv_fkey"
            columns: ["loadCarrierId"]
            isOneToOne: false
            referencedRelation: "loadCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_transactions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_transactions_FmFUpL7BwKzp_fkey"
            columns: ["returnOrderId"]
            isOneToOne: false
            referencedRelation: "returnOrders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_transactions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_transactions_suborder_id_suborders_id_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_stock_transactions_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      loadCarrierUnits: {
        Row: {
          createdAt: string
          createdBy: string | null
          currentZoneId: string | null
          id: string
          loadCarrierId: string
          number: number
          orgId: string
          suborderId: string
          total: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          currentZoneId?: string | null
          id?: string
          loadCarrierId: string
          number: number
          orgId?: string
          suborderId: string
          total: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          currentZoneId?: string | null
          id?: string
          loadCarrierId?: string
          number?: number
          orgId?: string
          suborderId?: string
          total?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "load_carrier_units_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_units_current_zone_id_warehouse_zones_id_fkey"
            columns: ["currentZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_units_load_carrier_id_load_carriers_id_fkey"
            columns: ["loadCarrierId"]
            isOneToOne: false
            referencedRelation: "loadCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_units_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_units_suborder_id_suborders_id_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "load_carrier_units_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      noteFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          noteId: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          noteId: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          noteId?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "note_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "note_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "note_files_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "note_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "note_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      notes: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          isImportant: boolean
          note: string
          orgId: string
          parentNoteId: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          isImportant?: boolean
          note: string
          orgId?: string
          parentNoteId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          isImportant?: boolean
          note?: string
          orgId?: string
          parentNoteId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "notes_parent_note_id_fkey"
            columns: ["parentNoteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "notes_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      notesAudit: {
        Row: {
          changedAt: string | null
          changedBy: string | null
          id: string
          newData: Json | null
          noteId: string
          oldData: Json | null
          operation: Database["public"]["Enums"]["operation"]
          orgId: string
        }
        Insert: {
          changedAt?: string | null
          changedBy?: string | null
          id?: string
          newData?: Json | null
          noteId?: string
          oldData?: Json | null
          operation: Database["public"]["Enums"]["operation"]
          orgId?: string
        }
        Update: {
          changedAt?: string | null
          changedBy?: string | null
          id?: string
          newData?: Json | null
          noteId?: string
          oldData?: Json | null
          operation?: Database["public"]["Enums"]["operation"]
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "notes_audit_changed_by_users_id_fkey"
            columns: ["changedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "notes_audit_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "notes_audit_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      orderArticles: {
        Row: {
          articleId: string
          createdAt: string
          createdBy: string | null
          id: string
          openQuantity: number | null
          orderId: string
          orgId: string
          pickedQuantity: number
          quantity: number
          state: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleId: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          openQuantity?: number | null
          orderId: string
          orgId?: string
          pickedQuantity?: number
          quantity?: number
          state?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          openQuantity?: number | null
          orderId?: string
          orgId?: string
          pickedQuantity?: number
          quantity?: number
          state?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "order_articles_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_articles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_articles_order_id_orders_id_fkey"
            columns: ["orderId"]
            isOneToOne: false
            referencedRelation: "orders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_articles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_articles_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      orderLoadCarriers: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          loadCarrierId: string
          openQuantity: number | null
          orderId: string
          orgId: string
          pickedQuantity: number
          quantity: number
          state: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          loadCarrierId: string
          openQuantity?: number | null
          orderId: string
          orgId?: string
          pickedQuantity?: number
          quantity?: number
          state?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          loadCarrierId?: string
          openQuantity?: number | null
          orderId?: string
          orgId?: string
          pickedQuantity?: number
          quantity?: number
          state?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "order_load_carriers_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_load_carriers_load_carrier_id_load_carriers_id_fkey"
            columns: ["loadCarrierId"]
            isOneToOne: false
            referencedRelation: "loadCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_load_carriers_order_id_orders_id_fkey"
            columns: ["orderId"]
            isOneToOne: false
            referencedRelation: "orders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_load_carriers_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_load_carriers_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      orderNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orderId: string
          orgId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orderId: string
          orgId?: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orderId?: string
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "order_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_notes_order_id_orders_id_fkey"
            columns: ["orderId"]
            isOneToOne: false
            referencedRelation: "orders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      orders: {
        Row: {
          createdAt: string
          createdBy: string | null
          deliveryDate: string
          id: string
          lockedEndTime: string | null
          lockedStartTime: string | null
          note: string | null
          number: number
          orgId: string
          projectId: string
          state: Database["public"]["Enums"]["orderState"]
          tourWaveId: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          deliveryDate: string
          id?: string
          lockedEndTime?: string | null
          lockedStartTime?: string | null
          note?: string | null
          number: number
          orgId?: string
          projectId: string
          state?: Database["public"]["Enums"]["orderState"]
          tourWaveId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          deliveryDate?: string
          id?: string
          lockedEndTime?: string | null
          lockedStartTime?: string | null
          note?: string | null
          number?: number
          orgId?: string
          projectId?: string
          state?: Database["public"]["Enums"]["orderState"]
          tourWaveId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "orders_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "orders_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "orders_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "orders_tour_wave_id_tour_waves_id_fkey"
            columns: ["tourWaveId"]
            isOneToOne: false
            referencedRelation: "tourWaves"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "orders_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      orderStateTransitions: {
        Row: {
          changedAt: string
          changedBy: string | null
          fromState: Database["public"]["Enums"]["orderState"] | null
          id: string
          orderId: string
          orgId: string
          suborderId: string | null
          toState: Database["public"]["Enums"]["orderState"]
        }
        Insert: {
          changedAt?: string
          changedBy?: string | null
          fromState?: Database["public"]["Enums"]["orderState"] | null
          id?: string
          orderId: string
          orgId?: string
          suborderId?: string | null
          toState: Database["public"]["Enums"]["orderState"]
        }
        Update: {
          changedAt?: string
          changedBy?: string | null
          fromState?: Database["public"]["Enums"]["orderState"] | null
          id?: string
          orderId?: string
          orgId?: string
          suborderId?: string | null
          toState?: Database["public"]["Enums"]["orderState"]
        }
        Relationships: [
          {
            foreignKeyName: "order_state_transitions_changed_by_users_id_fkey"
            columns: ["changedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_state_transitions_order_id_orders_id_fkey"
            columns: ["orderId"]
            isOneToOne: false
            referencedRelation: "orders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_state_transitions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_state_transitions_suborder_id_suborders_id_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
        ]
      }
      orderTemplateArticles: {
        Row: {
          articleId: string | null
          createdAt: string
          createdBy: string | null
          id: string
          orderTemplateId: string
          orgId: string
          quantity: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleId?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          orderTemplateId: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleId?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          orderTemplateId?: string
          orgId?: string
          quantity?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "order_template_articles_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_template_articles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_template_articles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_template_articles_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_template_articles_yIRN0WC5grca_fkey"
            columns: ["orderTemplateId"]
            isOneToOne: false
            referencedRelation: "orderTemplates"
            referencedColumns: ["id"]
          },
        ]
      }
      orderTemplates: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          name: string
          orgId: string
          scope: Database["public"]["Enums"]["scope"]
          updatedAt: string | null
          updatedBy: string | null
          userId: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          name: string
          orgId?: string
          scope?: Database["public"]["Enums"]["scope"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          name?: string
          orgId?: string
          scope?: Database["public"]["Enums"]["scope"]
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "order_templates_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_templates_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_templates_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "order_templates_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationAdmins: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string
          userId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId: string
          userId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "organization_admins_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_admins_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_admins_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationAlerts: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          description: string | null
          dismissKey: string | null
          endDate: string | null
          href: string | null
          id: string
          isDismissable: boolean
          levelType: Database["public"]["Enums"]["alertLevelType"]
          orgId: string
          startDate: string | null
          title: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          description?: string | null
          dismissKey?: string | null
          endDate?: string | null
          href?: string | null
          id?: string
          isDismissable?: boolean
          levelType?: Database["public"]["Enums"]["alertLevelType"]
          orgId: string
          startDate?: string | null
          title?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          description?: string | null
          dismissKey?: string | null
          endDate?: string | null
          href?: string | null
          id?: string
          isDismissable?: boolean
          levelType?: Database["public"]["Enums"]["alertLevelType"]
          orgId?: string
          startDate?: string | null
          title?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_alerts_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_alerts_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_alerts_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationAlertTeams: {
        Row: {
          alertId: string
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          teamId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          alertId: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          teamId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          alertId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          teamId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_alert_teams_alert_id_organization_alerts_id_fkey"
            columns: ["alertId"]
            isOneToOne: false
            referencedRelation: "organizationAlerts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_alert_teams_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_alert_teams_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_alert_teams_team_id_teams_id_fkey"
            columns: ["teamId"]
            isOneToOne: false
            referencedRelation: "teams"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_alert_teams_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationIntegrations: {
        Row: {
          account: string | null
          apiKey: string | null
          clientId: string | null
          createdAt: string | null
          createdBy: string | null
          excludedOrgUnitIds: string[]
          id: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId: string | null
          password: string | null
          secret: string | null
          syncRoleId: string | null
          updatedAt: string | null
          updatedBy: string | null
          username: string | null
          workspaceId: string | null
        }
        Insert: {
          account?: string | null
          apiKey?: string | null
          clientId?: string | null
          createdAt?: string | null
          createdBy?: string | null
          excludedOrgUnitIds?: string[]
          id?: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId?: string | null
          password?: string | null
          secret?: string | null
          syncRoleId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          username?: string | null
          workspaceId?: string | null
        }
        Update: {
          account?: string | null
          apiKey?: string | null
          clientId?: string | null
          createdAt?: string | null
          createdBy?: string | null
          excludedOrgUnitIds?: string[]
          id?: string
          integrationType?: Database["public"]["Enums"]["integrationType"]
          orgId?: string | null
          password?: string | null
          secret?: string | null
          syncRoleId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          username?: string | null
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_integrations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_integrations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_integrations_sync_role_id_roles_id_fkey"
            columns: ["syncRoleId"]
            isOneToOne: false
            referencedRelation: "roles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_integrations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_integrations_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationInvitationCodes: {
        Row: {
          id: string
          orgId: string
          partnershipInvitationCode: string
          updatedAt: string
          userInvitationCode: string
        }
        Insert: {
          id?: string
          orgId: string
          partnershipInvitationCode?: string
          updatedAt?: string
          userInvitationCode?: string
        }
        Update: {
          id?: string
          orgId?: string
          partnershipInvitationCode?: string
          updatedAt?: string
          userInvitationCode?: string
        }
        Relationships: [
          {
            foreignKeyName: "organization_invitation_codes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: true
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationMailboxes: {
        Row: {
          createdAt: string
          createdBy: string | null
          emailAddress: string
          folder: string
          id: string
          imapHost: string
          imapPort: number
          imapSecurity: Database["public"]["Enums"]["mailboxImapSecurity"]
          imapUsername: string
          isPaused: boolean
          label: string
          orgId: string
          pollingIntervalMinutes: number
          purpose: Database["public"]["Enums"]["mailboxPurpose"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          emailAddress: string
          folder?: string
          id?: string
          imapHost: string
          imapPort?: number
          imapSecurity?: Database["public"]["Enums"]["mailboxImapSecurity"]
          imapUsername: string
          isPaused?: boolean
          label: string
          orgId?: string
          pollingIntervalMinutes?: number
          purpose: Database["public"]["Enums"]["mailboxPurpose"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          emailAddress?: string
          folder?: string
          id?: string
          imapHost?: string
          imapPort?: number
          imapSecurity?: Database["public"]["Enums"]["mailboxImapSecurity"]
          imapUsername?: string
          isPaused?: boolean
          label?: string
          orgId?: string
          pollingIntervalMinutes?: number
          purpose?: Database["public"]["Enums"]["mailboxPurpose"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_mailboxes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_mailboxes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_mailboxes_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationMailboxStates: {
        Row: {
          consecutiveFailures: number
          createdAt: string
          health: Database["public"]["Enums"]["mailboxHealth"]
          id: string
          lastError: string | null
          lastPolledAt: string | null
          lastSucceededAt: string | null
          mailboxId: string
          orgId: string
          secret: string
          syncCursor: Json | null
          updatedAt: string | null
        }
        Insert: {
          consecutiveFailures?: number
          createdAt?: string
          health?: Database["public"]["Enums"]["mailboxHealth"]
          id?: string
          lastError?: string | null
          lastPolledAt?: string | null
          lastSucceededAt?: string | null
          mailboxId: string
          orgId?: string
          secret: string
          syncCursor?: Json | null
          updatedAt?: string | null
        }
        Update: {
          consecutiveFailures?: number
          createdAt?: string
          health?: Database["public"]["Enums"]["mailboxHealth"]
          id?: string
          lastError?: string | null
          lastPolledAt?: string | null
          lastSucceededAt?: string | null
          mailboxId?: string
          orgId?: string
          secret?: string
          syncCursor?: Json | null
          updatedAt?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_mailbox_states_bAs7W9Cvcvh9_fkey"
            columns: ["mailboxId"]
            isOneToOne: true
            referencedRelation: "organizationMailboxes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_mailbox_states_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationMembers: {
        Row: {
          attendancePinCode: string | null
          createdAt: string | null
          id: string
          orgId: string
          role: string | null
          state: Database["public"]["Enums"]["state"]
          userId: string
        }
        Insert: {
          attendancePinCode?: string | null
          createdAt?: string | null
          id?: string
          orgId: string
          role?: string | null
          state?: Database["public"]["Enums"]["state"]
          userId: string
        }
        Update: {
          attendancePinCode?: string | null
          createdAt?: string | null
          id?: string
          orgId?: string
          role?: string | null
          state?: Database["public"]["Enums"]["state"]
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "organization_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_members_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationPartnershipAgreements: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          name: string | null
          note: string | null
          organizationPartnershipId: string
          orgId: string | null
          startDate: string
          type: Database["public"]["Enums"]["organizationPartnershipAgreementType"]
          unit: Database["public"]["Enums"]["unit"] | null
          updatedAt: string | null
          updatedBy: string | null
          value: number | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          name?: string | null
          note?: string | null
          organizationPartnershipId: string
          orgId?: string | null
          startDate: string
          type: Database["public"]["Enums"]["organizationPartnershipAgreementType"]
          unit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
          value?: number | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          name?: string | null
          note?: string | null
          organizationPartnershipId?: string
          orgId?: string | null
          startDate?: string
          type?: Database["public"]["Enums"]["organizationPartnershipAgreementType"]
          unit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
          value?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_partnership_agreements_CFMFFjYu9OSF_fkey"
            columns: ["organizationPartnershipId"]
            isOneToOne: false
            referencedRelation: "organizationPartnerships"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnership_agreements_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnership_agreements_O03lyuyrG5Vs_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnership_agreements_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationPartnershipNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          organizationPartnershipId: string
          orgId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          organizationPartnershipId: string
          orgId?: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          organizationPartnershipId?: string
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "organization_partnership_notes_CPreI1upxEoL_fkey"
            columns: ["organizationPartnershipId"]
            isOneToOne: false
            referencedRelation: "organizationPartnerships"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnership_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnership_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnership_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationPartnerships: {
        Row: {
          createdAt: string
          createdBy: string | null
          hostOrgId: string
          id: string
          partnerOrgId: string
          state: Database["public"]["Enums"]["state"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          hostOrgId: string
          id?: string
          partnerOrgId: string
          state?: Database["public"]["Enums"]["state"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          hostOrgId?: string
          id?: string
          partnerOrgId?: string
          state?: Database["public"]["Enums"]["state"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_partnerships_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnerships_host_org_id_organizations_id_fkey"
            columns: ["hostOrgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnerships_partner_org_id_organizations_id_fkey"
            columns: ["partnerOrgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_partnerships_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizations: {
        Row: {
          city: string | null
          color: Database["public"]["Enums"]["color"]
          country: string
          createdAt: string
          houseNumber: string | null
          id: string
          name: string
          size: string
          slug: string
          streetName: string | null
          updatedAt: string | null
          updatedBy: string | null
          zipCode: string | null
        }
        Insert: {
          city?: string | null
          color?: Database["public"]["Enums"]["color"]
          country?: string
          createdAt?: string
          houseNumber?: string | null
          id: string
          name: string
          size?: string
          slug: string
          streetName?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          zipCode?: string | null
        }
        Update: {
          city?: string | null
          color?: Database["public"]["Enums"]["color"]
          country?: string
          createdAt?: string
          houseNumber?: string | null
          id?: string
          name?: string
          size?: string
          slug?: string
          streetName?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          zipCode?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organizations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationServiceFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          organizationServiceId: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          organizationServiceId: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          organizationServiceId?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_service_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_files_nywUIWftKcuk_fkey"
            columns: ["organizationServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_files_nywUIWftKcuk_fkey"
            columns: ["organizationServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServicesWithFullNumber"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationServiceFulfillmentPartners: {
        Row: {
          contactId: string
          id: string
          orgId: string
          serviceId: string
        }
        Insert: {
          contactId: string
          id?: string
          orgId?: string
          serviceId: string
        }
        Update: {
          contactId?: string
          id?: string
          orgId?: string
          serviceId?: string
        }
        Relationships: [
          {
            foreignKeyName: "organization_service_fulfillment_partners_0sT2c3tyUK2w_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_fulfillment_partners_5JkCK63zmf2N_fkey"
            columns: ["serviceId"]
            isOneToOne: false
            referencedRelation: "organizationServices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_fulfillment_partners_5JkCK63zmf2N_fkey"
            columns: ["serviceId"]
            isOneToOne: false
            referencedRelation: "organizationServicesWithFullNumber"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_fulfillment_partners_X9kkpVPkCruT_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationServiceNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          organizationServiceId: string
          orgId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          organizationServiceId: string
          orgId?: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          organizationServiceId?: string
          orgId?: string
        }
        Relationships: [
          {
            foreignKeyName: "organization_service_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_notes_r5J8zf2XbKRE_fkey"
            columns: ["organizationServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_service_notes_r5J8zf2XbKRE_fkey"
            columns: ["organizationServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServicesWithFullNumber"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationServices: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          fulfillmentType: Database["public"]["Enums"]["serviceFulfillmentType"]
          id: string
          longText: string | null
          number: number | null
          orgId: string
          parentServiceId: string | null
          shortText: string
          unit: Database["public"]["Enums"]["unit"] | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          fulfillmentType?: Database["public"]["Enums"]["serviceFulfillmentType"]
          id?: string
          longText?: string | null
          number?: number | null
          orgId: string
          parentServiceId?: string | null
          shortText: string
          unit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          fulfillmentType?: Database["public"]["Enums"]["serviceFulfillmentType"]
          id?: string
          longText?: string | null
          number?: number | null
          orgId?: string
          parentServiceId?: string | null
          shortText?: string
          unit?: Database["public"]["Enums"]["unit"] | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_services_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_parent_service_id_fkey"
            columns: ["parentServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_parent_service_id_fkey"
            columns: ["parentServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServicesWithFullNumber"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationSettings: {
        Row: {
          automaticBreakBufferMinutes: number
          businessHours: Json | null
          createdAt: string
          createdBy: string | null
          halfVacationDays: Json[] | null
          id: string
          invoicingPeriodUnit: Database["public"]["Enums"]["unit"]
          invoicingPeriodValue: number
          orgId: string
          partnerReportsEmail: string | null
          updatedAt: string | null
          updatedBy: string | null
          vacationDays: number
          vacationDaysAccrualType: Database["public"]["Enums"]["vacationDaysAccrualType"]
          vacationDaysExpire: boolean
          vacationDaysExpireAtDay: number | null
          vacationDaysExpireAtMonth: number | null
        }
        Insert: {
          automaticBreakBufferMinutes?: number
          businessHours?: Json | null
          createdAt?: string
          createdBy?: string | null
          halfVacationDays?: Json[] | null
          id?: string
          invoicingPeriodUnit?: Database["public"]["Enums"]["unit"]
          invoicingPeriodValue?: number
          orgId: string
          partnerReportsEmail?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          vacationDays?: number
          vacationDaysAccrualType?: Database["public"]["Enums"]["vacationDaysAccrualType"]
          vacationDaysExpire?: boolean
          vacationDaysExpireAtDay?: number | null
          vacationDaysExpireAtMonth?: number | null
        }
        Update: {
          automaticBreakBufferMinutes?: number
          businessHours?: Json | null
          createdAt?: string
          createdBy?: string | null
          halfVacationDays?: Json[] | null
          id?: string
          invoicingPeriodUnit?: Database["public"]["Enums"]["unit"]
          invoicingPeriodValue?: number
          orgId?: string
          partnerReportsEmail?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          vacationDays?: number
          vacationDaysAccrualType?: Database["public"]["Enums"]["vacationDaysAccrualType"]
          vacationDaysExpire?: boolean
          vacationDaysExpireAtDay?: number | null
          vacationDaysExpireAtMonth?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_settings_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_settings_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_settings_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationWorksiteAcknowledgementDefinitions: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          projectId: string | null
          state: Database["public"]["Enums"]["state"]
          text: string
          updatedAt: string | null
          updatedBy: string | null
          worksite: Database["public"]["Enums"]["attendanceWorksiteType"]
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          projectId?: string | null
          state?: Database["public"]["Enums"]["state"]
          text: string
          updatedAt?: string | null
          updatedBy?: string | null
          worksite: Database["public"]["Enums"]["attendanceWorksiteType"]
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          projectId?: string | null
          state?: Database["public"]["Enums"]["state"]
          text?: string
          updatedAt?: string | null
          updatedBy?: string | null
          worksite?: Database["public"]["Enums"]["attendanceWorksiteType"]
        }
        Relationships: [
          {
            foreignKeyName: "18WoxIZDyWzY_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "c6esE6UfNmCW_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "L9CDFwQXEE83_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "OfuC5X5tDK7P_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      organizationWorksiteDocumentFiles: {
        Row: {
          acknowledgementIntervalMonths: number
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string | null
          type: Database["public"]["Enums"]["documentType"]
          updatedAt: string | null
          updatedBy: string | null
          worksiteType:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
        }
        Insert: {
          acknowledgementIntervalMonths?: number
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string | null
          type?: Database["public"]["Enums"]["documentType"]
          updatedAt?: string | null
          updatedBy?: string | null
          worksiteType?:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
        }
        Update: {
          acknowledgementIntervalMonths?: number
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string | null
          type?: Database["public"]["Enums"]["documentType"]
          updatedAt?: string | null
          updatedBy?: string | null
          worksiteType?:
            | Database["public"]["Enums"]["attendanceWorksiteType"]
            | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_worksite_document_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_worksite_document_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_worksite_document_files_OarxoeGmtRaQ_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_worksite_document_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      outgoingEmails: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          email: string
          id: string
          orgId: string | null
          provider: Database["public"]["Enums"]["emailProvider"]
          providerEmailId: string
          subject: string
          type: Database["public"]["Enums"]["emailType"]
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          email: string
          id?: string
          orgId?: string | null
          provider: Database["public"]["Enums"]["emailProvider"]
          providerEmailId: string
          subject: string
          type: Database["public"]["Enums"]["emailType"]
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          email?: string
          id?: string
          orgId?: string | null
          provider?: Database["public"]["Enums"]["emailProvider"]
          providerEmailId?: string
          subject?: string
          type?: Database["public"]["Enums"]["emailType"]
        }
        Relationships: [
          {
            foreignKeyName: "emails_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "emails_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      outgoingInvoiceFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          outgoingInvoiceId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          outgoingInvoiceId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          outgoingInvoiceId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "invoice_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoice_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoice_files_invoice_id_invoices_id_fkey"
            columns: ["outgoingInvoiceId"]
            isOneToOne: false
            referencedRelation: "outgoingInvoices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoice_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoice_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      outgoingInvoices: {
        Row: {
          calculatedTo: string | null
          createdAt: string
          createdBy: string | null
          creationDate: string
          id: string
          note: string | null
          number: string
          orgId: string
          progressInvoiceNumber: number | null
          projectId: string
          state: Database["public"]["Enums"]["outgoingInvoiceState"]
          sum: number
          type: Database["public"]["Enums"]["outgoingInvoiceType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          calculatedTo?: string | null
          createdAt?: string
          createdBy?: string | null
          creationDate: string
          id?: string
          note?: string | null
          number: string
          orgId?: string
          progressInvoiceNumber?: number | null
          projectId: string
          state?: Database["public"]["Enums"]["outgoingInvoiceState"]
          sum: number
          type: Database["public"]["Enums"]["outgoingInvoiceType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          calculatedTo?: string | null
          createdAt?: string
          createdBy?: string | null
          creationDate?: string
          id?: string
          note?: string | null
          number?: string
          orgId?: string
          progressInvoiceNumber?: number | null
          projectId?: string
          state?: Database["public"]["Enums"]["outgoingInvoiceState"]
          sum?: number
          type?: Database["public"]["Enums"]["outgoingInvoiceType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "invoices_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoices_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoices_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "invoices_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      partnerReportFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          partnerReportId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          partnerReportId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          partnerReportId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "partner_report_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_files_partner_report_id_partner_reports_id_fkey"
            columns: ["partnerReportId"]
            isOneToOne: false
            referencedRelation: "partnerReports"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      partnerReports: {
        Row: {
          calculationType: Database["public"]["Enums"]["assignmentCalculationType"]
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string | null
          partnerReportSendAttemptId: string
          partnershipId: string
          projectId: string
          reportNumber: string
          total: number
          week: string
        }
        Insert: {
          calculationType: Database["public"]["Enums"]["assignmentCalculationType"]
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          partnerReportSendAttemptId: string
          partnershipId: string
          projectId: string
          reportNumber: string
          total: number
          week: string
        }
        Update: {
          calculationType?: Database["public"]["Enums"]["assignmentCalculationType"]
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          partnerReportSendAttemptId?: string
          partnershipId?: string
          projectId?: string
          reportNumber?: string
          total?: number
          week?: string
        }
        Relationships: [
          {
            foreignKeyName: "partner_reports_C33i98YAiVBf_fkey"
            columns: ["partnerReportSendAttemptId"]
            isOneToOne: false
            referencedRelation: "partnerReportSendAttempts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_reports_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_reports_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_reports_zDHusqufjmWx_fkey"
            columns: ["partnershipId"]
            isOneToOne: false
            referencedRelation: "organizationPartnerships"
            referencedColumns: ["id"]
          },
        ]
      }
      partnerReportSendAttemptOutgoingEmails: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string | null
          outgoingEmailId: string | null
          partnerReportSendAttemptId: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          outgoingEmailId?: string | null
          partnerReportSendAttemptId?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          outgoingEmailId?: string | null
          partnerReportSendAttemptId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "partner_report_send_attempt_emails_d9WBgHdFb0MT_fkey"
            columns: ["partnerReportSendAttemptId"]
            isOneToOne: false
            referencedRelation: "partnerReportSendAttempts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_send_attempt_emails_email_id_emails_id_fkey"
            columns: ["outgoingEmailId"]
            isOneToOne: false
            referencedRelation: "outgoingEmails"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_send_attempt_emails_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      partnerReportSendAttempts: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string | null
          partnershipId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          partnershipId?: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          partnershipId?: string
        }
        Relationships: [
          {
            foreignKeyName: "partner_report_send_attempts_76j5MveNvRPa_fkey"
            columns: ["partnershipId"]
            isOneToOne: false
            referencedRelation: "organizationPartnerships"
            referencedColumns: ["id"]
          },
        ]
      }
      partnerReportTrackingReferences: {
        Row: {
          calculationType: Database["public"]["Enums"]["assignmentCalculationType"]
          createdAt: string | null
          createdBy: string | null
          id: string
          invoiceNumber: string | null
          orgId: string
          partnerReportId: string
          partnershipId: string
          projectId: string
          state: Database["public"]["Enums"]["partnerReportState"]
          updatedAt: string | null
          updatedBy: string | null
          week: string
        }
        Insert: {
          calculationType: Database["public"]["Enums"]["assignmentCalculationType"]
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          invoiceNumber?: string | null
          orgId?: string
          partnerReportId: string
          partnershipId: string
          projectId: string
          state?: Database["public"]["Enums"]["partnerReportState"]
          updatedAt?: string | null
          updatedBy?: string | null
          week: string
        }
        Update: {
          calculationType?: Database["public"]["Enums"]["assignmentCalculationType"]
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          invoiceNumber?: string | null
          orgId?: string
          partnerReportId?: string
          partnershipId?: string
          projectId?: string
          state?: Database["public"]["Enums"]["partnerReportState"]
          updatedAt?: string | null
          updatedBy?: string | null
          week?: string
        }
        Relationships: [
          {
            foreignKeyName: "partner_report_tracking_references_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_tracking_references_eCXdHcD8nN87_fkey"
            columns: ["partnerReportId"]
            isOneToOne: false
            referencedRelation: "partnerReports"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_tracking_references_FemHey954blT_fkey"
            columns: ["partnershipId"]
            isOneToOne: false
            referencedRelation: "organizationPartnerships"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_tracking_references_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_tracking_references_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "partner_report_tracking_references_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      plans: {
        Row: {
          date: string
          id: string
          notificationsEnabled: boolean
          orgId: string
          publishedAt: string | null
          publishedBy: string | null
          skippedTickets: string[]
          state: Database["public"]["Enums"]["planState"]
          workspaceId: string | null
        }
        Insert: {
          date: string
          id?: string
          notificationsEnabled?: boolean
          orgId?: string
          publishedAt?: string | null
          publishedBy?: string | null
          skippedTickets?: string[]
          state?: Database["public"]["Enums"]["planState"]
          workspaceId?: string | null
        }
        Update: {
          date?: string
          id?: string
          notificationsEnabled?: boolean
          orgId?: string
          publishedAt?: string | null
          publishedBy?: string | null
          skippedTickets?: string[]
          state?: Database["public"]["Enums"]["planState"]
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "plans_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "plans_published_by_users_id_fkey"
            columns: ["publishedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "plans_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      plansAudit: {
        Row: {
          fromState: Database["public"]["Enums"]["planState"]
          id: string
          planId: string
          toState: Database["public"]["Enums"]["planState"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          fromState: Database["public"]["Enums"]["planState"]
          id?: string
          planId: string
          toState: Database["public"]["Enums"]["planState"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          fromState?: Database["public"]["Enums"]["planState"]
          id?: string
          planId?: string
          toState?: Database["public"]["Enums"]["planState"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "plans_audit_plan_id_plans_id_fkey"
            columns: ["planId"]
            isOneToOne: false
            referencedRelation: "plans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "plans_audit_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectContactMemberOverrides: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          overrides: Json | null
          projectContactMemberId: string
          projectId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          overrides?: Json | null
          projectContactMemberId: string
          projectId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          overrides?: Json | null
          projectContactMemberId?: string
          projectId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "project_contact_member_overrides_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_member_overrides_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_member_overrides_POZH0IzGecbe_fkey"
            columns: ["projectContactMemberId"]
            isOneToOne: false
            referencedRelation: "projectContactMembers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_member_overrides_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_member_overrides_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectContactMembers: {
        Row: {
          contactMemberId: string
          id: string
          orgId: string
          projectContactId: string
        }
        Insert: {
          contactMemberId: string
          id?: string
          orgId?: string
          projectContactId: string
        }
        Update: {
          contactMemberId?: string
          id?: string
          orgId?: string
          projectContactId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_contact_members_2LpsS27YkPr7_fkey"
            columns: ["contactMemberId"]
            isOneToOne: false
            referencedRelation: "contactMembers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_members_Znic2kBGldBd_fkey"
            columns: ["projectContactId"]
            isOneToOne: false
            referencedRelation: "projectContacts"
            referencedColumns: ["id"]
          },
        ]
      }
      projectContactOverrides: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          overrides: Json | null
          projectContactId: string
          projectId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          overrides?: Json | null
          projectContactId: string
          projectId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          overrides?: Json | null
          projectContactId?: string
          projectId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "project_contact_overrides_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_overrides_o5lIW0Ntxqmf_fkey"
            columns: ["projectContactId"]
            isOneToOne: false
            referencedRelation: "projectContacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_overrides_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_overrides_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contact_overrides_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectContacts: {
        Row: {
          contactId: string
          id: string
          orgId: string
          projectId: string
        }
        Insert: {
          contactId: string
          id?: string
          orgId?: string
          projectId: string
        }
        Update: {
          contactId?: string
          id?: string
          orgId?: string
          projectId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_contacts_contact_id_contacts_id_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contacts_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_contacts_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
        ]
      }
      projectDocumentFiles: {
        Row: {
          acknowledgementIntervalMonths: number
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string | null
          projectId: string
          type: Database["public"]["Enums"]["documentType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          acknowledgementIntervalMonths?: number
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string | null
          projectId: string
          type?: Database["public"]["Enums"]["documentType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          acknowledgementIntervalMonths?: number
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string | null
          projectId?: string
          type?: Database["public"]["Enums"]["documentType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "project_document_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_document_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_document_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_document_files_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_document_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string | null
          projectId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string | null
          projectId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string | null
          projectId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "project_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_files_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectIntegrations: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          identifier: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId: string
          projectId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          identifier: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId?: string
          projectId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          identifier?: string
          integrationType?: Database["public"]["Enums"]["integrationType"]
          orgId?: string
          projectId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "project_integrations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_integrations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_integrations_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_integrations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectMembers: {
        Row: {
          id: string
          orgId: string
          projectId: string
          role: Database["public"]["Enums"]["projectRole"]
          userId: string
        }
        Insert: {
          id?: string
          orgId?: string
          projectId?: string
          role: Database["public"]["Enums"]["projectRole"]
          userId?: string
        }
        Update: {
          id?: string
          orgId?: string
          projectId?: string
          role?: Database["public"]["Enums"]["projectRole"]
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_members_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_members_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projectNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          projectId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          projectId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          projectId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_notes_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
        ]
      }
      projectResourceLinks: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          linkId: string
          orgId: string
          projectId: string
          ticketId: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          linkId: string
          orgId?: string
          projectId?: string
          ticketId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          linkId?: string
          orgId?: string
          projectId?: string
          ticketId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "project_resource_links_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_resource_links_link_id_resource_links_id_fkey"
            columns: ["linkId"]
            isOneToOne: false
            referencedRelation: "resourceLinks"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_resource_links_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_resource_links_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_resource_links_ticket_id_tickets_id_fkey"
            columns: ["ticketId"]
            isOneToOne: false
            referencedRelation: "tickets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_resource_links_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      projects: {
        Row: {
          city: string
          clientId: string | null
          createdAt: string
          createdBy: string | null
          geometry: unknown
          houseNumber: string | null
          id: string
          latitude: number | null
          longitude: number | null
          name: string
          note: string | null
          number: string | null
          orgId: string
          relatedProjectId: string | null
          state: Database["public"]["Enums"]["projectState"]
          streetName: string
          updatedAt: string | null
          updatedBy: string | null
          weekdays: number[]
          workspaceId: string
          zipCode: string
        }
        Insert: {
          city: string
          clientId?: string | null
          createdAt?: string
          createdBy?: string | null
          geometry?: unknown
          houseNumber?: string | null
          id?: string
          latitude?: number | null
          longitude?: number | null
          name: string
          note?: string | null
          number?: string | null
          orgId?: string
          relatedProjectId?: string | null
          state?: Database["public"]["Enums"]["projectState"]
          streetName: string
          updatedAt?: string | null
          updatedBy?: string | null
          weekdays?: number[]
          workspaceId: string
          zipCode: string
        }
        Update: {
          city?: string
          clientId?: string | null
          createdAt?: string
          createdBy?: string | null
          geometry?: unknown
          houseNumber?: string | null
          id?: string
          latitude?: number | null
          longitude?: number | null
          name?: string
          note?: string | null
          number?: string | null
          orgId?: string
          relatedProjectId?: string | null
          state?: Database["public"]["Enums"]["projectState"]
          streetName?: string
          updatedAt?: string | null
          updatedBy?: string | null
          weekdays?: number[]
          workspaceId?: string
          zipCode?: string
        }
        Relationships: [
          {
            foreignKeyName: "projects_client_id_contacts_id_fkey"
            columns: ["clientId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_related_project_id_fkey"
            columns: ["relatedProjectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      projectsAudit: {
        Row: {
          changedAt: string
          changedBy: string | null
          id: string
          newData: Json | null
          oldData: Json | null
          operation: Database["public"]["Enums"]["operation"]
          orgId: string
          projectId: string
        }
        Insert: {
          changedAt?: string
          changedBy?: string | null
          id?: string
          newData?: Json | null
          oldData?: Json | null
          operation: Database["public"]["Enums"]["operation"]
          orgId?: string
          projectId: string
        }
        Update: {
          changedAt?: string
          changedBy?: string | null
          id?: string
          newData?: Json | null
          oldData?: Json | null
          operation?: Database["public"]["Enums"]["operation"]
          orgId?: string
          projectId?: string
        }
        Relationships: [
          {
            foreignKeyName: "projects_audit_changed_by_users_id_fkey"
            columns: ["changedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_audit_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "projects_audit_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
        ]
      }
      projectSettings: {
        Row: {
          id: string
          invoicingPeriodUnit: Database["public"]["Enums"]["unit"] | null
          invoicingPeriodValue: number | null
          projectId: string
        }
        Insert: {
          id?: string
          invoicingPeriodUnit?: Database["public"]["Enums"]["unit"] | null
          invoicingPeriodValue?: number | null
          projectId: string
        }
        Update: {
          id?: string
          invoicingPeriodUnit?: Database["public"]["Enums"]["unit"] | null
          invoicingPeriodValue?: number | null
          projectId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_settings_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
        ]
      }
      projectSummaries: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string
          projectId: string
          summary: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string
          projectId: string
          summary: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string
          projectId?: string
          summary?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_summaries_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_summaries_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_summaries_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
        ]
      }
      projectTimelineNoteNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          projectTimelineNoteId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          projectTimelineNoteId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          projectTimelineNoteId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_timeline_note_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_timeline_note_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_timeline_note_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_timeline_note_notes_ZUqAvcQgjpDH_fkey"
            columns: ["projectTimelineNoteId"]
            isOneToOne: false
            referencedRelation: "projectTimelineNotes"
            referencedColumns: ["id"]
          },
        ]
      }
      projectTimelineNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          date: string
          id: string
          noteId: string
          orgId: string
          projectId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          date: string
          id?: string
          noteId: string
          orgId?: string
          projectId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          date?: string
          id?: string
          noteId?: string
          orgId?: string
          projectId?: string
        }
        Relationships: [
          {
            foreignKeyName: "project_timeline_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_timeline_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_timeline_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "project_timeline_notes_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
        ]
      }
      protocolCallRequestEvents: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          note: string | null
          orgId: string
          protocolId: string
          type: Database["public"]["Enums"]["protocolCallRequestEventType"]
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          note?: string | null
          orgId?: string
          protocolId: string
          type: Database["public"]["Enums"]["protocolCallRequestEventType"]
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          note?: string | null
          orgId?: string
          protocolId?: string
          type?: Database["public"]["Enums"]["protocolCallRequestEventType"]
        }
        Relationships: [
          {
            foreignKeyName: "protocol_call_request_events_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_call_request_events_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_call_request_events_protocol_id_protocols_id_fkey"
            columns: ["protocolId"]
            isOneToOne: false
            referencedRelation: "protocols"
            referencedColumns: ["id"]
          },
        ]
      }
      protocolFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          protocolId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          protocolId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          protocolId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "protocol_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_files_protocol_id_protocols_id_fkey"
            columns: ["protocolId"]
            isOneToOne: false
            referencedRelation: "protocols"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      protocolInvolvements: {
        Row: {
          contactMemberId: string | null
          id: string
          isNotified: boolean
          protocolId: string
          userId: string | null
        }
        Insert: {
          contactMemberId?: string | null
          id?: string
          isNotified?: boolean
          protocolId: string
          userId?: string | null
        }
        Update: {
          contactMemberId?: string | null
          id?: string
          isNotified?: boolean
          protocolId?: string
          userId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "protocol_involvements_contact_member_id_contact_members_id_fkey"
            columns: ["contactMemberId"]
            isOneToOne: false
            referencedRelation: "contactMembers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_involvements_protocol_id_protocols_id_fkey"
            columns: ["protocolId"]
            isOneToOne: false
            referencedRelation: "protocols"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_involvements_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      protocolNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          protocolId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          protocolId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          protocolId?: string
        }
        Relationships: [
          {
            foreignKeyName: "protocol_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_notes_protocol_id_protocols_id_fkey"
            columns: ["protocolId"]
            isOneToOne: false
            referencedRelation: "protocols"
            referencedColumns: ["id"]
          },
        ]
      }
      protocolOutgoingEmails: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          outgoingEmailId: string | null
          protocolId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          outgoingEmailId?: string | null
          protocolId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          outgoingEmailId?: string | null
          protocolId?: string
        }
        Relationships: [
          {
            foreignKeyName: "protocol_emails_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_emails_email_id_emails_id_fkey"
            columns: ["outgoingEmailId"]
            isOneToOne: false
            referencedRelation: "outgoingEmails"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_emails_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocol_emails_protocol_id_protocols_id_fkey"
            columns: ["protocolId"]
            isOneToOne: false
            referencedRelation: "protocols"
            referencedColumns: ["id"]
          },
        ]
      }
      protocols: {
        Row: {
          callRequestBy: string | null
          callRequestByIdSendNotification: boolean | null
          callRequestCallbackTime: string | null
          callRequestFor: string | null
          callRequestForIdSendNotification: boolean | null
          callRequestPriority: Database["public"]["Enums"]["priority"] | null
          content: Json | null
          createdAt: string | null
          createdBy: string | null
          date: string | null
          description: string | null
          endTime: string | null
          id: string
          orgId: string
          projectId: string | null
          startTime: string | null
          title: string | null
          type: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          callRequestBy?: string | null
          callRequestByIdSendNotification?: boolean | null
          callRequestCallbackTime?: string | null
          callRequestFor?: string | null
          callRequestForIdSendNotification?: boolean | null
          callRequestPriority?: Database["public"]["Enums"]["priority"] | null
          content?: Json | null
          createdAt?: string | null
          createdBy?: string | null
          date?: string | null
          description?: string | null
          endTime?: string | null
          id?: string
          orgId?: string
          projectId?: string | null
          startTime?: string | null
          title?: string | null
          type?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          callRequestBy?: string | null
          callRequestByIdSendNotification?: boolean | null
          callRequestCallbackTime?: string | null
          callRequestFor?: string | null
          callRequestForIdSendNotification?: boolean | null
          callRequestPriority?: Database["public"]["Enums"]["priority"] | null
          content?: Json | null
          createdAt?: string | null
          createdBy?: string | null
          date?: string | null
          description?: string | null
          endTime?: string | null
          id?: string
          orgId?: string
          projectId?: string | null
          startTime?: string | null
          title?: string | null
          type?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "protocols_call_request_by_contact_members_id_fkey"
            columns: ["callRequestBy"]
            isOneToOne: false
            referencedRelation: "contactMembers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_call_request_for_users_id_fkey"
            columns: ["callRequestFor"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      protocolsAudit: {
        Row: {
          changedAt: string | null
          changedBy: string | null
          id: string
          newData: Json | null
          oldData: Json | null
          operation: string | null
          orgId: string
          protocolId: string
        }
        Insert: {
          changedAt?: string | null
          changedBy?: string | null
          id?: string
          newData?: Json | null
          oldData?: Json | null
          operation?: string | null
          orgId?: string
          protocolId: string
        }
        Update: {
          changedAt?: string | null
          changedBy?: string | null
          id?: string
          newData?: Json | null
          oldData?: Json | null
          operation?: string | null
          orgId?: string
          protocolId?: string
        }
        Relationships: [
          {
            foreignKeyName: "protocols_audit_changed_by_users_id_fkey"
            columns: ["changedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_audit_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "protocols_audit_protocol_id_protocols_id_fkey"
            columns: ["protocolId"]
            isOneToOne: false
            referencedRelation: "protocols"
            referencedColumns: ["id"]
          },
        ]
      }
      resourceLinks: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          link: string
          name: string | null
          orgId: string
          type: Database["public"]["Enums"]["resourceLinkType"] | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          link: string
          name?: string | null
          orgId?: string
          type?: Database["public"]["Enums"]["resourceLinkType"] | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          link?: string
          name?: string | null
          orgId?: string
          type?: Database["public"]["Enums"]["resourceLinkType"] | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "resource_links_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "resource_links_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "resource_links_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      returnOrderFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          returnOrderId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          returnOrderId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          returnOrderId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "return_order_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_files_return_order_id_return_orders_id_fkey"
            columns: ["returnOrderId"]
            isOneToOne: false
            referencedRelation: "returnOrders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      returnOrderNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          returnOrderId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          returnOrderId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          returnOrderId?: string
        }
        Relationships: [
          {
            foreignKeyName: "return_order_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_notes_return_order_id_return_orders_id_fkey"
            columns: ["returnOrderId"]
            isOneToOne: false
            referencedRelation: "returnOrders"
            referencedColumns: ["id"]
          },
        ]
      }
      returnOrders: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          note: string | null
          number: number
          orgId: string
          projectId: string
          state: Database["public"]["Enums"]["returnOrderState"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          note?: string | null
          number: number
          orgId?: string
          projectId: string
          state?: Database["public"]["Enums"]["returnOrderState"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          note?: string | null
          number?: number
          orgId?: string
          projectId?: string
          state?: Database["public"]["Enums"]["returnOrderState"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "return_orders_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_orders_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_orders_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_orders_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      returnOrderVehicles: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          returnOrderId: string
          vehicleId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          returnOrderId: string
          vehicleId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          returnOrderId?: string
          vehicleId?: string
        }
        Relationships: [
          {
            foreignKeyName: "return_order_vehicles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_vehicles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_vehicles_return_order_id_return_orders_id_fkey"
            columns: ["returnOrderId"]
            isOneToOne: false
            referencedRelation: "returnOrders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "return_order_vehicles_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      rolePermissions: {
        Row: {
          action: string
          conditions: Json | null
          createdAt: string
          id: string
          orgId: string
          roleId: string
          subject: string
          updatedAt: string
        }
        Insert: {
          action: string
          conditions?: Json | null
          createdAt?: string
          id?: string
          orgId?: string
          roleId: string
          subject: string
          updatedAt?: string
        }
        Update: {
          action?: string
          conditions?: Json | null
          createdAt?: string
          id?: string
          orgId?: string
          roleId?: string
          subject?: string
          updatedAt?: string
        }
        Relationships: [
          {
            foreignKeyName: "role_permissions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "role_permissions_role_id_roles_id_fkey"
            columns: ["roleId"]
            isOneToOne: false
            referencedRelation: "roles"
            referencedColumns: ["id"]
          },
        ]
      }
      roles: {
        Row: {
          createdAt: string
          id: string
          isSystem: boolean
          name: string
          orgId: string
          updatedAt: string
        }
        Insert: {
          createdAt?: string
          id?: string
          isSystem?: boolean
          name: string
          orgId: string
          updatedAt?: string
        }
        Update: {
          createdAt?: string
          id?: string
          isSystem?: boolean
          name?: string
          orgId?: string
          updatedAt?: string
        }
        Relationships: [
          {
            foreignKeyName: "roles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          serviceCalculationId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          serviceCalculationId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          serviceCalculationId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_files_d8DivsJvAcvs_fkey"
            columns: ["serviceCalculationId"]
            isOneToOne: false
            referencedRelation: "serviceCalculations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationItemFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          serviceCalculationItemId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          serviceCalculationItemId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          serviceCalculationItemId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_item_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_files_uUGTbKRYbbQw_fkey"
            columns: ["serviceCalculationItemId"]
            isOneToOne: false
            referencedRelation: "serviceCalculationItems"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationItemNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          serviceCalculationItemId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          serviceCalculationItemId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          serviceCalculationItemId?: string
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_item_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_notes_UtY16s09tPfY_fkey"
            columns: ["serviceCalculationItemId"]
            isOneToOne: false
            referencedRelation: "serviceCalculationItems"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationItemPositions: {
        Row: {
          createdAt: string
          createdBy: string | null
          height: number | null
          id: string
          length: number | null
          manualMeasurement: number | null
          meters: number | null
          name: string | null
          orgId: string
          quantity: number | null
          ranking: number
          serviceCalculationItemId: string
          sum: number | null
          updatedAt: string | null
          updatedBy: string | null
          width: number | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          height?: number | null
          id?: string
          length?: number | null
          manualMeasurement?: number | null
          meters?: number | null
          name?: string | null
          orgId?: string
          quantity?: number | null
          ranking: number
          serviceCalculationItemId?: string
          sum?: number | null
          updatedAt?: string | null
          updatedBy?: string | null
          width?: number | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          height?: number | null
          id?: string
          length?: number | null
          manualMeasurement?: number | null
          meters?: number | null
          name?: string | null
          orgId?: string
          quantity?: number | null
          ranking?: number
          serviceCalculationItemId?: string
          sum?: number | null
          updatedAt?: string | null
          updatedBy?: string | null
          width?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_item_positions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_positions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_positions_pNKWSTPtjqbv_fkey"
            columns: ["serviceCalculationItemId"]
            isOneToOne: false
            referencedRelation: "serviceCalculationItems"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_item_positions_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationItems: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          isEventualPosition: boolean
          longText: string | null
          organizationServiceId: string | null
          orgId: string
          parentServiceCalculationItemId: string | null
          quantity: number | null
          ranking: number
          serviceCalculationId: string
          shortText: string
          total: number
          type: Database["public"]["Enums"]["serviceCalculationItemType"]
          unit: Database["public"]["Enums"]["unit"] | null
          unitPrice: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          isEventualPosition?: boolean
          longText?: string | null
          organizationServiceId?: string | null
          orgId?: string
          parentServiceCalculationItemId?: string | null
          quantity?: number | null
          ranking?: number
          serviceCalculationId: string
          shortText: string
          total?: number
          type?: Database["public"]["Enums"]["serviceCalculationItemType"]
          unit?: Database["public"]["Enums"]["unit"] | null
          unitPrice?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          isEventualPosition?: boolean
          longText?: string | null
          organizationServiceId?: string | null
          orgId?: string
          parentServiceCalculationItemId?: string | null
          quantity?: number | null
          ranking?: number
          serviceCalculationId?: string
          shortText?: string
          total?: number
          type?: Database["public"]["Enums"]["serviceCalculationItemType"]
          unit?: Database["public"]["Enums"]["unit"] | null
          unitPrice?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_items_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_items_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_items_parent_item_id_fkey"
            columns: ["parentServiceCalculationItemId"]
            isOneToOne: false
            referencedRelation: "serviceCalculationItems"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_items_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_items_vTJOBNVJdR5v_fkey"
            columns: ["serviceCalculationId"]
            isOneToOne: false
            referencedRelation: "serviceCalculations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_items_yBY7JAnPSFXn_fkey"
            columns: ["organizationServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_items_yBY7JAnPSFXn_fkey"
            columns: ["organizationServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServicesWithFullNumber"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationMembers: {
        Row: {
          createdAt: string
          id: string
          orgId: string
          serviceCalculationId: string
          source: Database["public"]["Enums"]["serviceCalculationMemberSource"]
          userId: string
        }
        Insert: {
          createdAt?: string
          id?: string
          orgId?: string
          serviceCalculationId: string
          source?: Database["public"]["Enums"]["serviceCalculationMemberSource"]
          userId: string
        }
        Update: {
          createdAt?: string
          id?: string
          orgId?: string
          serviceCalculationId?: string
          source?: Database["public"]["Enums"]["serviceCalculationMemberSource"]
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_members_sAx6xTIUKpFg_fkey"
            columns: ["serviceCalculationId"]
            isOneToOne: false
            referencedRelation: "serviceCalculations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_members_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationMeta: {
        Row: {
          city: string | null
          clientId: string | null
          createdAt: string
          createdBy: string | null
          houseNumber: string | null
          id: string
          offerNumber: string | null
          orgId: string
          projectId: string | null
          projectName: string | null
          serviceCalculationId: string
          streetName: string | null
          updatedAt: string | null
          updatedBy: string | null
          zipCode: string | null
        }
        Insert: {
          city?: string | null
          clientId?: string | null
          createdAt?: string
          createdBy?: string | null
          houseNumber?: string | null
          id?: string
          offerNumber?: string | null
          orgId?: string
          projectId?: string | null
          projectName?: string | null
          serviceCalculationId: string
          streetName?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          zipCode?: string | null
        }
        Update: {
          city?: string | null
          clientId?: string | null
          createdAt?: string
          createdBy?: string | null
          houseNumber?: string | null
          id?: string
          offerNumber?: string | null
          orgId?: string
          projectId?: string | null
          projectName?: string | null
          serviceCalculationId?: string
          streetName?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          zipCode?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_meta_client_id_contacts_id_fkey"
            columns: ["clientId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_meta_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_meta_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_meta_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_meta_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_meta_XbkGjJ1rUofI_fkey"
            columns: ["serviceCalculationId"]
            isOneToOne: false
            referencedRelation: "serviceCalculations"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculationNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          serviceCalculationId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          serviceCalculationId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          serviceCalculationId?: string
        }
        Relationships: [
          {
            foreignKeyName: "service_calculation_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_notes_CWojWbxzEekc_fkey"
            columns: ["serviceCalculationId"]
            isOneToOne: false
            referencedRelation: "serviceCalculations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculation_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      serviceCalculations: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          lockedAt: string | null
          lockedBy: string | null
          lockSource:
            | Database["public"]["Enums"]["calculationLockSource"]
            | null
          name: string
          orgId: string | null
          state: Database["public"]["Enums"]["calculationState"]
          total: number
          type: Database["public"]["Enums"]["calculationType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          lockedAt?: string | null
          lockedBy?: string | null
          lockSource?:
            | Database["public"]["Enums"]["calculationLockSource"]
            | null
          name?: string
          orgId?: string | null
          state?: Database["public"]["Enums"]["calculationState"]
          total?: number
          type: Database["public"]["Enums"]["calculationType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          lockedAt?: string | null
          lockedBy?: string | null
          lockSource?:
            | Database["public"]["Enums"]["calculationLockSource"]
            | null
          name?: string
          orgId?: string | null
          state?: Database["public"]["Enums"]["calculationState"]
          total?: number
          type?: Database["public"]["Enums"]["calculationType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "service_calculations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculations_locked_by_users_id_fkey"
            columns: ["lockedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "service_calculations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      sessions: {
        Row: {
          activeOrganizationId: string | null
          createdAt: string
          expiresAt: string
          id: string
          ipAddress: string | null
          token: string
          updatedAt: string
          userAgent: string | null
          userId: string
        }
        Insert: {
          activeOrganizationId?: string | null
          createdAt?: string
          expiresAt: string
          id: string
          ipAddress?: string | null
          token: string
          updatedAt: string
          userAgent?: string | null
          userId: string
        }
        Update: {
          activeOrganizationId?: string | null
          createdAt?: string
          expiresAt?: string
          id?: string
          ipAddress?: string | null
          token?: string
          updatedAt?: string
          userAgent?: string | null
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "sessions_active_organization_id_organizations_id_fkey"
            columns: ["activeOrganizationId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sessions_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      statusAlerts: {
        Row: {
          createdAt: string
          id: string
          path: string | null
          permission: string | null
          status: number | null
          userId: string | null
        }
        Insert: {
          createdAt?: string
          id?: string
          path?: string | null
          permission?: string | null
          status?: number | null
          userId?: string | null
        }
        Update: {
          createdAt?: string
          id?: string
          path?: string | null
          permission?: string | null
          status?: number | null
          userId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "status_alerts_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      stockTransactions: {
        Row: {
          articleId: string
          articleLocationStockTransactionId: string | null
          createdAt: string
          createdBy: string | null
          id: string
          operation: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId: string
          quantity: number
          type: Database["public"]["Enums"]["transactionType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleId: string
          articleLocationStockTransactionId?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          operation: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId?: string
          quantity: number
          type: Database["public"]["Enums"]["transactionType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleId?: string
          articleLocationStockTransactionId?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          operation?: Database["public"]["Enums"]["stockTransactionOperation"]
          orgId?: string
          quantity?: number
          type?: Database["public"]["Enums"]["transactionType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stock_transactions_8qjODatD2tU3_fkey"
            columns: ["articleLocationStockTransactionId"]
            isOneToOne: false
            referencedRelation: "articleLocationStockTransactions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_transactions_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_transactions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_transactions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_transactions_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      suborderFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          suborderId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          suborderId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          suborderId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "suborder_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_files_suborder_id_suborders_id_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      suborderLoadCarriers: {
        Row: {
          bookedAt: string | null
          createdAt: string
          createdBy: string | null
          id: string
          loadCarrierId: string
          orgId: string
          quantity: number
          suborderId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          bookedAt?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          loadCarrierId: string
          orgId?: string
          quantity: number
          suborderId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          bookedAt?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          loadCarrierId?: string
          orgId?: string
          quantity?: number
          suborderId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "suborder_load_carriers_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_load_carriers_load_carrier_id_load_carriers_id_fkey"
            columns: ["loadCarrierId"]
            isOneToOne: false
            referencedRelation: "loadCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_load_carriers_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_load_carriers_suborder_id_suborders_id_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_load_carriers_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      suborderNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          suborderId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          suborderId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          suborderId?: string
        }
        Relationships: [
          {
            foreignKeyName: "suborder_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborder_notes_suborder_id_suborders_id_fkey"
            columns: ["suborderId"]
            isOneToOne: false
            referencedRelation: "suborders"
            referencedColumns: ["id"]
          },
        ]
      }
      suborders: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          number: number
          orderId: string
          orgId: string
          state: Database["public"]["Enums"]["orderState"]
          updatedAt: string | null
          updatedBy: string | null
          warehouseZoneId: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          number?: number
          orderId: string
          orgId?: string
          state?: Database["public"]["Enums"]["orderState"]
          updatedAt?: string | null
          updatedBy?: string | null
          warehouseZoneId?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          number?: number
          orderId?: string
          orgId?: string
          state?: Database["public"]["Enums"]["orderState"]
          updatedAt?: string | null
          updatedBy?: string | null
          warehouseZoneId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "suborders_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborders_order_id_orders_id_fkey"
            columns: ["orderId"]
            isOneToOne: false
            referencedRelation: "orders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborders_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborders_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "suborders_warehouse_zone_id_warehouse_zones_id_fkey"
            columns: ["warehouseZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlanNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          substitutionPlanId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          substitutionPlanId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          substitutionPlanId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "substitution_plan_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_notes_tpwvcA0BPale_fkey"
            columns: ["substitutionPlanId"]
            isOneToOne: false
            referencedRelation: "substitutionPlans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_notes_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlanOutgoingEmails: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string | null
          outgoingEmailId: string | null
          substitutionPlanId: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          outgoingEmailId?: string | null
          substitutionPlanId?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          outgoingEmailId?: string | null
          substitutionPlanId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "substitution_plan_emails_email_id_emails_id_fkey"
            columns: ["outgoingEmailId"]
            isOneToOne: false
            referencedRelation: "outgoingEmails"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_emails_iAXB302zJsIS_fkey"
            columns: ["substitutionPlanId"]
            isOneToOne: false
            referencedRelation: "substitutionPlans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_emails_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlanProjectItemAssignments: {
        Row: {
          id: string
          orgId: string
          substitutionPlanProjectItemId: string
          userId: string | null
        }
        Insert: {
          id?: string
          orgId?: string
          substitutionPlanProjectItemId: string
          userId?: string | null
        }
        Update: {
          id?: string
          orgId?: string
          substitutionPlanProjectItemId?: string
          userId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "substitution_plan_project_item_assignments_0iPD54O5Y6ZN_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_item_assignments_6D75ZmbEmHnE_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_item_assignments_9GnhJDtvlb0X_fkey"
            columns: ["substitutionPlanProjectItemId"]
            isOneToOne: false
            referencedRelation: "substitutionPlanProjectItems"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlanProjectItemContactNotifications: {
        Row: {
          contactMemberId: string | null
          id: string
          orgId: string
          substitutionPlanProjectItemId: string
        }
        Insert: {
          contactMemberId?: string | null
          id?: string
          orgId?: string
          substitutionPlanProjectItemId: string
        }
        Update: {
          contactMemberId?: string | null
          id?: string
          orgId?: string
          substitutionPlanProjectItemId?: string
        }
        Relationships: [
          {
            foreignKeyName: "aORlkgghvWZy_fkey"
            columns: ["contactMemberId"]
            isOneToOne: false
            referencedRelation: "contactMembers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "PICUelzJUAiY_fkey"
            columns: ["substitutionPlanProjectItemId"]
            isOneToOne: false
            referencedRelation: "substitutionPlanProjectItems"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "xXCu3XTLcCer_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlanProjectItemNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          substitutionPlanProjectItemId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          substitutionPlanProjectItemId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          substitutionPlanProjectItemId?: string
        }
        Relationships: [
          {
            foreignKeyName: "substitution_plan_project_item_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_item_notes_MM2lr2tlc1eb_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_item_notes_NGfBf9lY66SU_fkey"
            columns: ["substitutionPlanProjectItemId"]
            isOneToOne: false
            referencedRelation: "substitutionPlanProjectItems"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_item_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlanProjectItems: {
        Row: {
          id: string
          isAssignmentNotRequired: boolean
          orgId: string
          projectId: string
          quickNote: string | null
          substitutionPlanId: string
        }
        Insert: {
          id?: string
          isAssignmentNotRequired?: boolean
          orgId?: string
          projectId: string
          quickNote?: string | null
          substitutionPlanId: string
        }
        Update: {
          id?: string
          isAssignmentNotRequired?: boolean
          orgId?: string
          projectId?: string
          quickNote?: string | null
          substitutionPlanId?: string
        }
        Relationships: [
          {
            foreignKeyName: "substitution_plan_project_items_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_items_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plan_project_items_RvYCkBXN9fjx_fkey"
            columns: ["substitutionPlanId"]
            isOneToOne: false
            referencedRelation: "substitutionPlans"
            referencedColumns: ["id"]
          },
        ]
      }
      substitutionPlans: {
        Row: {
          absenceId: string
          endDate: string
          id: string
          isSent: boolean
          orgId: string
          scheduledNotificationTime: string
          startDate: string
          state: Database["public"]["Enums"]["state"]
          userId: string
        }
        Insert: {
          absenceId: string
          endDate: string
          id?: string
          isSent?: boolean
          orgId?: string
          scheduledNotificationTime?: string
          startDate: string
          state?: Database["public"]["Enums"]["state"]
          userId: string
        }
        Update: {
          absenceId?: string
          endDate?: string
          id?: string
          isSent?: boolean
          orgId?: string
          scheduledNotificationTime?: string
          startDate?: string
          state?: Database["public"]["Enums"]["state"]
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "substitution_plans_absence_id_absences_id_fkey"
            columns: ["absenceId"]
            isOneToOne: false
            referencedRelation: "absences"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plans_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "substitution_plans_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      teamCapabilities: {
        Row: {
          capability: Database["public"]["Enums"]["teamCapability"]
          id: string
          orgId: string
          teamId: string
        }
        Insert: {
          capability: Database["public"]["Enums"]["teamCapability"]
          id?: string
          orgId?: string
          teamId?: string
        }
        Update: {
          capability?: Database["public"]["Enums"]["teamCapability"]
          id?: string
          orgId?: string
          teamId?: string
        }
        Relationships: [
          {
            foreignKeyName: "team_capabilities_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_capabilities_team_id_teams_id_fkey"
            columns: ["teamId"]
            isOneToOne: false
            referencedRelation: "teams"
            referencedColumns: ["id"]
          },
        ]
      }
      teamLeaders: {
        Row: {
          id: string
          orgId: string
          teamId: string
          userId: string
        }
        Insert: {
          id?: string
          orgId?: string
          teamId: string
          userId: string
        }
        Update: {
          id?: string
          orgId?: string
          teamId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "team_leaders_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_leaders_team_id_teams_id_fkey"
            columns: ["teamId"]
            isOneToOne: false
            referencedRelation: "teams"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_leaders_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      teamMembers: {
        Row: {
          id: string
          orgId: string
          teamId: string
          userId: string
        }
        Insert: {
          id?: string
          orgId?: string
          teamId?: string
          userId: string
        }
        Update: {
          id?: string
          orgId?: string
          teamId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "team_members_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_members_team_id_teams_id_fkey"
            columns: ["teamId"]
            isOneToOne: false
            referencedRelation: "teams"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_members_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      teams: {
        Row: {
          id: string
          identifier: string | null
          name: string | null
          orgId: string
          source: string | null
          syncedMemberIds: string[] | null
          syncedName: string | null
        }
        Insert: {
          id?: string
          identifier?: string | null
          name?: string | null
          orgId?: string
          source?: string | null
          syncedMemberIds?: string[] | null
          syncedName?: string | null
        }
        Update: {
          id?: string
          identifier?: string | null
          name?: string | null
          orgId?: string
          source?: string | null
          syncedMemberIds?: string[] | null
          syncedName?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "teams_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      terminalPairings: {
        Row: {
          confirmedBy: string | null
          createdAt: string
          deviceId: string
          id: string
          orgId: string | null
          secretHash: string | null
          state: Database["public"]["Enums"]["terminalPairingState"]
          token: string | null
          updatedAt: string
          worksite: Database["public"]["Enums"]["attendanceWorksiteType"]
        }
        Insert: {
          confirmedBy?: string | null
          createdAt?: string
          deviceId: string
          id?: string
          orgId?: string | null
          secretHash?: string | null
          state?: Database["public"]["Enums"]["terminalPairingState"]
          token?: string | null
          updatedAt?: string
          worksite?: Database["public"]["Enums"]["attendanceWorksiteType"]
        }
        Update: {
          confirmedBy?: string | null
          createdAt?: string
          deviceId?: string
          id?: string
          orgId?: string | null
          secretHash?: string | null
          state?: Database["public"]["Enums"]["terminalPairingState"]
          token?: string | null
          updatedAt?: string
          worksite?: Database["public"]["Enums"]["attendanceWorksiteType"]
        }
        Relationships: [
          {
            foreignKeyName: "terminal_pairings_confirmed_by_users_id_fkey"
            columns: ["confirmedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "terminal_pairings_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignmentMeasurementStatements: {
        Row: {
          answeredAt: string
          answeredBy: string | null
          closedAt: string | null
          closedBy: string | null
          id: string
          isClosed: boolean
          orgId: string
          statement: Database["public"]["Enums"]["ticketAssignmentMeasurementStatement"]
          ticketAssignmentId: string
        }
        Insert: {
          answeredAt?: string
          answeredBy?: string | null
          closedAt?: string | null
          closedBy?: string | null
          id?: string
          isClosed?: boolean
          orgId?: string
          statement: Database["public"]["Enums"]["ticketAssignmentMeasurementStatement"]
          ticketAssignmentId: string
        }
        Update: {
          answeredAt?: string
          answeredBy?: string | null
          closedAt?: string | null
          closedBy?: string | null
          id?: string
          isClosed?: boolean
          orgId?: string
          statement?: Database["public"]["Enums"]["ticketAssignmentMeasurementStatement"]
          ticketAssignmentId?: string
        }
        Relationships: [
          {
            foreignKeyName: "ticket_assignment_measurement_statements_2jXRTlLiqTHL_fkey"
            columns: ["answeredBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_measurement_statements_iQzMp7jUJMko_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_measurement_statements_nK6d4M3pGBzp_fkey"
            columns: ["ticketAssignmentId"]
            isOneToOne: true
            referencedRelation: "ticketAssignments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_measurement_statements_ODENciBLFpYC_fkey"
            columns: ["closedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignmentNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          ticketAssignmentId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          ticketAssignmentId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          ticketAssignmentId?: string
        }
        Relationships: [
          {
            foreignKeyName: "ticket_assignment_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_notes_JLWBufI5zoE7_fkey"
            columns: ["ticketAssignmentId"]
            isOneToOne: false
            referencedRelation: "ticketAssignments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignmentReferenceBookings: {
        Row: {
          checkIn: string
          checkOut: string
          guestName: string | null
          id: string
          note: string | null
          orgId: string
          pause: number
          ranking: number
          referenceId: string
          updatedAt: string
          userId: string | null
        }
        Insert: {
          checkIn: string
          checkOut: string
          guestName?: string | null
          id?: string
          note?: string | null
          orgId: string
          pause?: number
          ranking: number
          referenceId: string
          updatedAt?: string
          userId?: string | null
        }
        Update: {
          checkIn?: string
          checkOut?: string
          guestName?: string | null
          id?: string
          note?: string | null
          orgId?: string
          pause?: number
          ranking?: number
          referenceId?: string
          updatedAt?: string
          userId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "ticket_assignment_reference_bookings_ehm8gCW0Wg9D_fkey"
            columns: ["referenceId"]
            isOneToOne: false
            referencedRelation: "ticketAssignmentReferences"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_reference_bookings_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_reference_bookings_w0fGOP3zwYUd_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignmentReferenceBookingsAdjustments: {
        Row: {
          bookingId: string
          checkIn: string | null
          checkOut: string | null
          createdAt: string
          createdBy: string | null
          id: string
          note: string | null
          orgId: string
          pause: number | null
          result: Database["public"]["Enums"]["bookingResult"] | null
          updatedAt: string
        }
        Insert: {
          bookingId: string
          checkIn?: string | null
          checkOut?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          note?: string | null
          orgId: string
          pause?: number | null
          result?: Database["public"]["Enums"]["bookingResult"] | null
          updatedAt?: string
        }
        Update: {
          bookingId?: string
          checkIn?: string | null
          checkOut?: string | null
          createdAt?: string
          createdBy?: string | null
          id?: string
          note?: string | null
          orgId?: string
          pause?: number | null
          result?: Database["public"]["Enums"]["bookingResult"] | null
          updatedAt?: string
        }
        Relationships: [
          {
            foreignKeyName: "PJrzAYUxLlf0_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "SWAehBbYbvgU_fkey"
            columns: ["bookingId"]
            isOneToOne: false
            referencedRelation: "ticketAssignmentReferenceBookings"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "UcJWUKqekadM_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignmentReferenceCalculations: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string | null
          serviceCalculationId: string
          ticketAssignmentReferenceId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          serviceCalculationId: string
          ticketAssignmentReferenceId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          serviceCalculationId?: string
          ticketAssignmentReferenceId?: string
        }
        Relationships: [
          {
            foreignKeyName: "ticket_assignment_reference_calculations_dkr0aLJjw9Rm_fkey"
            columns: ["serviceCalculationId"]
            isOneToOne: false
            referencedRelation: "serviceCalculations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_reference_calculations_VS8aE1snG89c_fkey"
            columns: ["ticketAssignmentReferenceId"]
            isOneToOne: true
            referencedRelation: "ticketAssignmentReferences"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignmentReferences: {
        Row: {
          approvedAt: string | null
          approvedBy: string | null
          calculationType: Database["public"]["Enums"]["assignmentCalculationType"]
          crewId: string
          id: string
          isApproved: boolean
          isExternalPlan: boolean
          isInternalPlan: boolean
          isReviewed: boolean
          orgId: string
          partnerReportId: string | null
          projectId: string
          reviewedAt: string | null
          reviewedBy: string | null
          state: Database["public"]["Enums"]["ticketAssignmentReferencesState"]
        }
        Insert: {
          approvedAt?: string | null
          approvedBy?: string | null
          calculationType?: Database["public"]["Enums"]["assignmentCalculationType"]
          crewId: string
          id?: string
          isApproved?: boolean
          isExternalPlan: boolean
          isInternalPlan: boolean
          isReviewed?: boolean
          orgId?: string
          partnerReportId?: string | null
          projectId: string
          reviewedAt?: string | null
          reviewedBy?: string | null
          state?: Database["public"]["Enums"]["ticketAssignmentReferencesState"]
        }
        Update: {
          approvedAt?: string | null
          approvedBy?: string | null
          calculationType?: Database["public"]["Enums"]["assignmentCalculationType"]
          crewId?: string
          id?: string
          isApproved?: boolean
          isExternalPlan?: boolean
          isInternalPlan?: boolean
          isReviewed?: boolean
          orgId?: string
          partnerReportId?: string | null
          projectId?: string
          reviewedAt?: string | null
          reviewedBy?: string | null
          state?: Database["public"]["Enums"]["ticketAssignmentReferencesState"]
        }
        Relationships: [
          {
            foreignKeyName: "ticket_assignment_references_approved_by_users_id_fkey"
            columns: ["approvedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_references_crew_id_crews_id_fkey"
            columns: ["crewId"]
            isOneToOne: false
            referencedRelation: "crews"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_references_hdb7lyrGhVUe_fkey"
            columns: ["partnerReportId"]
            isOneToOne: false
            referencedRelation: "partnerReports"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_references_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_references_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignment_references_reviewed_by_users_id_fkey"
            columns: ["reviewedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketAssignments: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          crewId: string
          id: string
          orgId: string
          projectId: string
          ranking: number
          referenceId: string
          ticketId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          crewId: string
          id?: string
          orgId?: string
          projectId: string
          ranking: number
          referenceId: string
          ticketId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          crewId?: string
          id?: string
          orgId?: string
          projectId?: string
          ranking?: number
          referenceId?: string
          ticketId?: string
        }
        Relationships: [
          {
            foreignKeyName: "ticket_assignments_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignments_crew_id_crews_id_fkey"
            columns: ["crewId"]
            isOneToOne: false
            referencedRelation: "crews"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignments_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignments_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignments_ticket_id_tickets_id_fkey"
            columns: ["ticketId"]
            isOneToOne: false
            referencedRelation: "tickets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_assignments_ZcDtUWiS1WbB_fkey"
            columns: ["referenceId"]
            isOneToOne: false
            referencedRelation: "ticketAssignmentReferences"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string | null
          projectId: string
          ticketId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string | null
          projectId: string
          ticketId: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string | null
          projectId?: string
          ticketId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "ticket_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_files_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_files_ticket_id_tickets_id_fkey"
            columns: ["ticketId"]
            isOneToOne: false
            referencedRelation: "tickets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      tickets: {
        Row: {
          assigneeMember: string | null
          assigneePartnership: string | null
          createdAt: string
          createdBy: string | null
          dateMode: Database["public"]["Enums"]["dateMode"] | null
          description: string
          endDate: string
          estimatedDays: number
          id: string
          note: string | null
          number: string
          orgId: string
          projectId: string
          startDate: string
          state: Database["public"]["Enums"]["projectState"]
          type: string
          updatedAt: string | null
          updatedBy: string | null
          workStartDate: string | null
        }
        Insert: {
          assigneeMember?: string | null
          assigneePartnership?: string | null
          createdAt?: string
          createdBy?: string | null
          dateMode?: Database["public"]["Enums"]["dateMode"] | null
          description: string
          endDate: string
          estimatedDays: number
          id?: string
          note?: string | null
          number: string
          orgId?: string
          projectId: string
          startDate: string
          state?: Database["public"]["Enums"]["projectState"]
          type: string
          updatedAt?: string | null
          updatedBy?: string | null
          workStartDate?: string | null
        }
        Update: {
          assigneeMember?: string | null
          assigneePartnership?: string | null
          createdAt?: string
          createdBy?: string | null
          dateMode?: Database["public"]["Enums"]["dateMode"] | null
          description?: string
          endDate?: string
          estimatedDays?: number
          id?: string
          note?: string | null
          number?: string
          orgId?: string
          projectId?: string
          startDate?: string
          state?: Database["public"]["Enums"]["projectState"]
          type?: string
          updatedAt?: string | null
          updatedBy?: string | null
          workStartDate?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "tickets_assignee_member_users_id_fkey"
            columns: ["assigneeMember"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_assignee_partnership_organization_partnerships_id_fkey"
            columns: ["assigneePartnership"]
            isOneToOne: false
            referencedRelation: "organizationPartnerships"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_project_id_projects_id_fkey"
            columns: ["projectId"]
            isOneToOne: false
            referencedRelation: "projects"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_type_ticket_types_id_fkey"
            columns: ["type"]
            isOneToOne: false
            referencedRelation: "ticketTypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketTypes: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string
          createdBy: string | null
          icon: Database["public"]["Enums"]["iconName"]
          id: string
          name: string
          orgId: string
          ranking: number
          state: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId: string | null
        }
        Insert: {
          color: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon: Database["public"]["Enums"]["iconName"]
          id?: string
          name: string
          orgId?: string
          ranking: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          icon?: Database["public"]["Enums"]["iconName"]
          id?: string
          name?: string
          orgId?: string
          ranking?: number
          state?: Database["public"]["Enums"]["ticketTypeState"]
          workspaceId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "ticket_types_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_types_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_types_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: false
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      ticketWorkExclusions: {
        Row: {
          createdAt: string
          createdBy: string | null
          date: string
          id: string
          note: string | null
          orgId: string
          ticketId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          date: string
          id?: string
          note?: string | null
          orgId?: string
          ticketId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          date?: string
          id?: string
          note?: string | null
          orgId?: string
          ticketId?: string
        }
        Relationships: [
          {
            foreignKeyName: "ticket_work_exclusions_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_work_exclusions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "ticket_work_exclusions_ticket_id_tickets_id_fkey"
            columns: ["ticketId"]
            isOneToOne: false
            referencedRelation: "tickets"
            referencedColumns: ["id"]
          },
        ]
      }
      tourWaves: {
        Row: {
          createdAt: string
          createdBy: string | null
          cutoffOffset: number
          endTime: string
          id: string
          name: string
          orgId: string
          startTime: string
          updatedAt: string | null
          updatedBy: string | null
          weekdays: number[]
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          cutoffOffset?: number
          endTime: string
          id?: string
          name: string
          orgId?: string
          startTime: string
          updatedAt?: string | null
          updatedBy?: string | null
          weekdays: number[]
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          cutoffOffset?: number
          endTime?: string
          id?: string
          name?: string
          orgId?: string
          startTime?: string
          updatedAt?: string | null
          updatedBy?: string | null
          weekdays?: number[]
        }
        Relationships: [
          {
            foreignKeyName: "tour_waves_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tour_waves_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tour_waves_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      transferCarrierNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          transferCarrierId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          transferCarrierId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          transferCarrierId?: string
        }
        Relationships: [
          {
            foreignKeyName: "transfer_carrier_notes_aJdWDEwM1Tyf_fkey"
            columns: ["transferCarrierId"]
            isOneToOne: false
            referencedRelation: "transferCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transfer_carrier_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transfer_carrier_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transfer_carrier_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      transferCarriers: {
        Row: {
          createdAt: string
          createdBy: string | null
          currentZoneId: string | null
          description: string | null
          id: string
          name: string | null
          number: number
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          currentZoneId?: string | null
          description?: string | null
          id?: string
          name?: string | null
          number: number
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          currentZoneId?: string | null
          description?: string | null
          id?: string
          name?: string | null
          number?: number
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "transfer_carriers_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transfer_carriers_current_zone_id_warehouse_zones_id_fkey"
            columns: ["currentZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transfer_carriers_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transfer_carriers_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      transportOrderEvents: {
        Row: {
          changedAt: string
          changedBy: string | null
          event: Database["public"]["Enums"]["transportOrderEvent"]
          id: string
          orgId: string
          transportOrderId: string
        }
        Insert: {
          changedAt?: string
          changedBy?: string | null
          event: Database["public"]["Enums"]["transportOrderEvent"]
          id?: string
          orgId?: string
          transportOrderId: string
        }
        Update: {
          changedAt?: string
          changedBy?: string | null
          event?: Database["public"]["Enums"]["transportOrderEvent"]
          id?: string
          orgId?: string
          transportOrderId?: string
        }
        Relationships: [
          {
            foreignKeyName: "transport_order_events_7fMMXaTP73Vt_fkey"
            columns: ["transportOrderId"]
            isOneToOne: false
            referencedRelation: "transportOrders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_order_events_changed_by_users_id_fkey"
            columns: ["changedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_order_events_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      transportOrders: {
        Row: {
          articleLocationId: string | null
          completedAt: string | null
          completedBy: string | null
          createdAt: string
          createdBy: string | null
          fromZoneId: string
          id: string
          loadCarrierUnitId: string | null
          number: number
          orgId: string
          pickedUpAt: string | null
          pickedUpBy: string | null
          quantity: number | null
          returnOrderId: string | null
          state: Database["public"]["Enums"]["transportOrderState"]
          toZoneId: string
          transferCarrierId: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleLocationId?: string | null
          completedAt?: string | null
          completedBy?: string | null
          createdAt?: string
          createdBy?: string | null
          fromZoneId: string
          id?: string
          loadCarrierUnitId?: string | null
          number: number
          orgId?: string
          pickedUpAt?: string | null
          pickedUpBy?: string | null
          quantity?: number | null
          returnOrderId?: string | null
          state?: Database["public"]["Enums"]["transportOrderState"]
          toZoneId: string
          transferCarrierId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleLocationId?: string | null
          completedAt?: string | null
          completedBy?: string | null
          createdAt?: string
          createdBy?: string | null
          fromZoneId?: string
          id?: string
          loadCarrierUnitId?: string | null
          number?: number
          orgId?: string
          pickedUpAt?: string | null
          pickedUpBy?: string | null
          quantity?: number | null
          returnOrderId?: string | null
          state?: Database["public"]["Enums"]["transportOrderState"]
          toZoneId?: string
          transferCarrierId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "transport_orders_article_location_id_article_locations_id_fkey"
            columns: ["articleLocationId"]
            isOneToOne: false
            referencedRelation: "articleLocations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_completed_by_users_id_fkey"
            columns: ["completedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_from_zone_id_warehouse_zones_id_fkey"
            columns: ["fromZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_iHT81QFKYN38_fkey"
            columns: ["loadCarrierUnitId"]
            isOneToOne: false
            referencedRelation: "loadCarrierUnits"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_picked_up_by_users_id_fkey"
            columns: ["pickedUpBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_return_order_id_return_orders_id_fkey"
            columns: ["returnOrderId"]
            isOneToOne: false
            referencedRelation: "returnOrders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_to_zone_id_warehouse_zones_id_fkey"
            columns: ["toZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_transfer_carrier_id_transfer_carriers_id_fkey"
            columns: ["transferCarrierId"]
            isOneToOne: false
            referencedRelation: "transferCarriers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transport_orders_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userAcknowledgementDefinitionAcceptances: {
        Row: {
          acknowledgementDefinitionId: string | null
          acknowledgementDefinitionText: string
          attendanceId: string
          createdAt: string
          createdBy: string
          id: string
          ipAddress: string | null
          orgId: string
          userId: string
        }
        Insert: {
          acknowledgementDefinitionId?: string | null
          acknowledgementDefinitionText: string
          attendanceId: string
          createdAt?: string
          createdBy?: string
          id?: string
          ipAddress?: string | null
          orgId: string
          userId: string
        }
        Update: {
          acknowledgementDefinitionId?: string | null
          acknowledgementDefinitionText?: string
          attendanceId?: string
          createdAt?: string
          createdBy?: string
          id?: string
          ipAddress?: string | null
          orgId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_acknowledgement_definition_acceptances_AxRQ5xsCS74M_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_acknowledgement_definition_acceptances_dmPsFeQJ1UDd_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_acknowledgement_definition_acceptances_QvegUy7DuXk9_fkey"
            columns: ["acknowledgementDefinitionId"]
            isOneToOne: false
            referencedRelation: "organizationWorksiteAcknowledgementDefinitions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_acknowledgement_definition_acceptances_xvb4bokAK5qs_fkey"
            columns: ["attendanceId"]
            isOneToOne: false
            referencedRelation: "attendances"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_acknowledgement_definition_acceptances_ZSNycoB1Tdt5_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      userAssignments: {
        Row: {
          createdAt: string
          createdBy: string | null
          crewId: string
          id: string
          orgId: string
          planId: string
          ranking: number
          userId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          crewId: string
          id?: string
          orgId?: string
          planId: string
          ranking: number
          userId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          crewId?: string
          id?: string
          orgId?: string
          planId?: string
          ranking?: number
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_assignments_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_assignments_crew_id_crews_id_fkey"
            columns: ["crewId"]
            isOneToOne: false
            referencedRelation: "crews"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_assignments_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_assignments_plan_id_plans_id_fkey"
            columns: ["planId"]
            isOneToOne: false
            referencedRelation: "plans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_assignments_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userIntegrations: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          identifier: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
          userId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          identifier: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          userId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          identifier?: string
          integrationType?: Database["public"]["Enums"]["integrationType"]
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_integrations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_integrations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_integrations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_integrations_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userInvitations: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          createdUserId: string | null
          email: string
          id: string
          orgId: string
          otp: string
          state: Database["public"]["Enums"]["invitationState"]
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          createdUserId?: string | null
          email: string
          id?: string
          orgId?: string
          otp: string
          state?: Database["public"]["Enums"]["invitationState"]
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          createdUserId?: string | null
          email?: string
          id?: string
          orgId?: string
          otp?: string
          state?: Database["public"]["Enums"]["invitationState"]
        }
        Relationships: [
          {
            foreignKeyName: "user_invitations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_invitations_created_user_id_users_id_fkey"
            columns: ["createdUserId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_invitations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
        ]
      }
      userNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          userId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          userId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_notes_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userPermissions: {
        Row: {
          action: string
          conditions: Json | null
          createdAt: string
          id: string
          orgId: string
          subject: string
          updatedAt: string
          userId: string
        }
        Insert: {
          action: string
          conditions?: Json | null
          createdAt?: string
          id?: string
          orgId: string
          subject: string
          updatedAt?: string
          userId: string
        }
        Update: {
          action?: string
          conditions?: Json | null
          createdAt?: string
          id?: string
          orgId?: string
          subject?: string
          updatedAt?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_permissions_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_permissions_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userPushOptOuts: {
        Row: {
          createdAt: string
          id: string
          kind: Database["public"]["Enums"]["notificationKind"]
          userId: string
        }
        Insert: {
          createdAt?: string
          id?: string
          kind: Database["public"]["Enums"]["notificationKind"]
          userId?: string
        }
        Update: {
          createdAt?: string
          id?: string
          kind?: Database["public"]["Enums"]["notificationKind"]
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_push_opt_outs_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userPushTokens: {
        Row: {
          id: string
          meta: Json | null
          provider: Database["public"]["Enums"]["pushTokenProvider"]
          token: string
          userId: string
        }
        Insert: {
          id?: string
          meta?: Json | null
          provider?: Database["public"]["Enums"]["pushTokenProvider"]
          token: string
          userId?: string
        }
        Update: {
          id?: string
          meta?: Json | null
          provider?: Database["public"]["Enums"]["pushTokenProvider"]
          token?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_push_tokens_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userRiskAssessmentAcknowledgements: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          ipAddress: string | null
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
          userId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          ipAddress?: string | null
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          ipAddress?: string | null
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_risk_assessment_acknowledgements_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_risk_assessment_acknowledgements_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_risk_assessment_acknowledgements_l3EUjGcsjQaC_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_risk_assessment_acknowledgements_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_risk_assessment_acknowledgements_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      userRoles: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          roleId: string
          userId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId: string
          roleId: string
          userId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          roleId?: string
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_roles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_roles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_roles_role_id_roles_id_fkey"
            columns: ["roleId"]
            isOneToOne: false
            referencedRelation: "roles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_roles_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      users: {
        Row: {
          createdAt: string | null
          email: string | null
          emailVerified: boolean
          firstName: string
          id: string
          image: string | null
          initials: string | null
          language: string | null
          lastName: string
          name: string | null
          phone: string | null
          state: Database["public"]["Enums"]["userState"]
          updatedAt: string
        }
        Insert: {
          createdAt?: string | null
          email?: string | null
          emailVerified?: boolean
          firstName: string
          id: string
          image?: string | null
          initials?: string | null
          language?: string | null
          lastName: string
          name?: string | null
          phone?: string | null
          state?: Database["public"]["Enums"]["userState"]
          updatedAt?: string
        }
        Update: {
          createdAt?: string | null
          email?: string | null
          emailVerified?: boolean
          firstName?: string
          id?: string
          image?: string | null
          initials?: string | null
          language?: string | null
          lastName?: string
          name?: string | null
          phone?: string | null
          state?: Database["public"]["Enums"]["userState"]
          updatedAt?: string
        }
        Relationships: []
      }
      userSettings: {
        Row: {
          createdAt: string
          id: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
          userId: string
        }
        Insert: {
          createdAt?: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          userId: string
        }
        Update: {
          createdAt?: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          userId?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_settings_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_settings_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_settings_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicleAssignments: {
        Row: {
          createdAt: string
          createdBy: string | null
          crewId: string
          id: string
          orgId: string
          planId: string
          updatedAt: string | null
          updatedBy: string | null
          vehicleId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          crewId: string
          id?: string
          orgId?: string
          planId: string
          updatedAt?: string | null
          updatedBy?: string | null
          vehicleId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          crewId?: string
          id?: string
          orgId?: string
          planId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          vehicleId?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_assignments_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_crew_id_crews_id_fkey"
            columns: ["crewId"]
            isOneToOne: false
            referencedRelation: "crews"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_plan_id_plans_id_fkey"
            columns: ["planId"]
            isOneToOne: false
            referencedRelation: "plans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicleAssignmentsPlan: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          planId: string
          userId: string | null
          vehicleId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          planId: string
          userId?: string | null
          vehicleId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          planId?: string
          userId?: string | null
          vehicleId?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_assignments_plan_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_plan_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_plan_plan_id_plans_id_fkey"
            columns: ["planId"]
            isOneToOne: false
            referencedRelation: "plans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_plan_user_id_users_id_fkey"
            columns: ["userId"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_assignments_plan_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicleCranes: {
        Row: {
          angle: number | null
          id: string
          maximumLoad: Json
          name: string | null
          orgId: string
          position: Database["public"]["Enums"]["cranePosition"]
          vehicleId: string
        }
        Insert: {
          angle?: number | null
          id?: string
          maximumLoad: Json
          name?: string | null
          orgId?: string
          position: Database["public"]["Enums"]["cranePosition"]
          vehicleId: string
        }
        Update: {
          angle?: number | null
          id?: string
          maximumLoad?: Json
          name?: string | null
          orgId?: string
          position?: Database["public"]["Enums"]["cranePosition"]
          vehicleId?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_cranes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_cranes_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicleDocumentFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string | null
          updatedAt: string | null
          updatedBy: string | null
          vehicleId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          vehicleId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          vehicleId?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_document_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_document_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_document_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_document_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_document_files_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicleIntegrations: {
        Row: {
          id: string
          identifier: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId: string
          vehicleId: string
        }
        Insert: {
          id?: string
          identifier: string
          integrationType: Database["public"]["Enums"]["integrationType"]
          orgId?: string
          vehicleId: string
        }
        Update: {
          id?: string
          identifier?: string
          integrationType?: Database["public"]["Enums"]["integrationType"]
          orgId?: string
          vehicleId?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_integrations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_integrations_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicleNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          vehicleId: string | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          vehicleId?: string | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          vehicleId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_notes_vehicle_id_vehicles_id_fkey"
            columns: ["vehicleId"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicles: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          depth: number | null
          firstRegistration: string | null
          flatbedDepth: number | null
          flatbedWidth: number | null
          fuelType: Database["public"]["Enums"]["fuelType"] | null
          height: number | null
          hsn: string | null
          id: string
          licensePlate: string
          manufacturer: string | null
          maximumLoadKg: number | null
          orgId: string
          tsn: string | null
          type: Database["public"]["Enums"]["vehicleType"]
          updatedAt: string | null
          updatedBy: string | null
          vin: string | null
          width: number | null
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          depth?: number | null
          firstRegistration?: string | null
          flatbedDepth?: number | null
          flatbedWidth?: number | null
          fuelType?: Database["public"]["Enums"]["fuelType"] | null
          height?: number | null
          hsn?: string | null
          id?: string
          licensePlate: string
          manufacturer?: string | null
          maximumLoadKg?: number | null
          orgId?: string
          tsn?: string | null
          type: Database["public"]["Enums"]["vehicleType"]
          updatedAt?: string | null
          updatedBy?: string | null
          vin?: string | null
          width?: number | null
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          depth?: number | null
          firstRegistration?: string | null
          flatbedDepth?: number | null
          flatbedWidth?: number | null
          fuelType?: Database["public"]["Enums"]["fuelType"] | null
          height?: number | null
          hsn?: string | null
          id?: string
          licensePlate?: string
          manufacturer?: string | null
          maximumLoadKg?: number | null
          orgId?: string
          tsn?: string | null
          type?: Database["public"]["Enums"]["vehicleType"]
          updatedAt?: string | null
          updatedBy?: string | null
          vin?: string | null
          width?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "vehicles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicles_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      vendorArticles: {
        Row: {
          articleId: string
          contactId: string
          createdAt: string
          createdBy: string | null
          id: string
          identifier: string
          orgId: string
          purchasePrice: number
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          articleId?: string
          contactId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          identifier: string
          orgId?: string
          purchasePrice?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          articleId?: string
          contactId?: string
          createdAt?: string
          createdBy?: string | null
          id?: string
          identifier?: string
          orgId?: string
          purchasePrice?: number
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "vendor_articles_article_id_articles_id_fkey"
            columns: ["articleId"]
            isOneToOne: false
            referencedRelation: "articles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vendor_articles_contact_id_contacts_id_fkey"
            columns: ["contactId"]
            isOneToOne: false
            referencedRelation: "contacts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vendor_articles_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vendor_articles_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vendor_articles_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      verifications: {
        Row: {
          createdAt: string
          expiresAt: string
          id: string
          identifier: string
          updatedAt: string
          value: string
        }
        Insert: {
          createdAt?: string
          expiresAt: string
          id: string
          identifier: string
          updatedAt?: string
          value: string
        }
        Update: {
          createdAt?: string
          expiresAt?: string
          id?: string
          identifier?: string
          updatedAt?: string
          value?: string
        }
        Relationships: []
      }
      videos: {
        Row: {
          aspectRatio: string | null
          createdAt: string
          createdBy: string | null
          duration: number | null
          id: string
          muxAssetId: string | null
          muxPlaybackId: string | null
          muxRetiringAssetIds: string[]
          muxSourceAssetId: string | null
          muxSourcePlaybackId: string | null
          muxUploadId: string | null
          orgId: string
          pendingKeepSource: boolean | null
          pendingRenderAssetId: string | null
          pendingRenderId: string | null
          pendingSegments: Json | null
          segments: Json | null
          sourceDuration: number | null
          status: Database["public"]["Enums"]["videoStatus"]
          unreferencedAt: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          aspectRatio?: string | null
          createdAt?: string
          createdBy?: string | null
          duration?: number | null
          id?: string
          muxAssetId?: string | null
          muxPlaybackId?: string | null
          muxRetiringAssetIds?: string[]
          muxSourceAssetId?: string | null
          muxSourcePlaybackId?: string | null
          muxUploadId?: string | null
          orgId?: string
          pendingKeepSource?: boolean | null
          pendingRenderAssetId?: string | null
          pendingRenderId?: string | null
          pendingSegments?: Json | null
          segments?: Json | null
          sourceDuration?: number | null
          status?: Database["public"]["Enums"]["videoStatus"]
          unreferencedAt?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          aspectRatio?: string | null
          createdAt?: string
          createdBy?: string | null
          duration?: number | null
          id?: string
          muxAssetId?: string | null
          muxPlaybackId?: string | null
          muxRetiringAssetIds?: string[]
          muxSourceAssetId?: string | null
          muxSourcePlaybackId?: string | null
          muxUploadId?: string | null
          orgId?: string
          pendingKeepSource?: boolean | null
          pendingRenderAssetId?: string | null
          pendingRenderId?: string | null
          pendingSegments?: Json | null
          segments?: Json | null
          sourceDuration?: number | null
          status?: Database["public"]["Enums"]["videoStatus"]
          unreferencedAt?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "videos_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "videos_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "videos_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      warehouseLocations: {
        Row: {
          axis: number | null
          createdAt: string
          createdBy: string | null
          floor: number | null
          id: string
          name: string | null
          orgId: string
          shelf: number | null
          updatedAt: string | null
          updatedBy: string | null
          warehouseZoneId: string | null
        }
        Insert: {
          axis?: number | null
          createdAt?: string
          createdBy?: string | null
          floor?: number | null
          id?: string
          name?: string | null
          orgId?: string
          shelf?: number | null
          updatedAt?: string | null
          updatedBy?: string | null
          warehouseZoneId?: string | null
        }
        Update: {
          axis?: number | null
          createdAt?: string
          createdBy?: string | null
          floor?: number | null
          id?: string
          name?: string | null
          orgId?: string
          shelf?: number | null
          updatedAt?: string | null
          updatedBy?: string | null
          warehouseZoneId?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "warehouse_locations_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_locations_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_locations_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_locations_warehouse_zone_id_warehouse_zones_id_fkey"
            columns: ["warehouseZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
        ]
      }
      warehouseZoneNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          warehouseZoneId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          warehouseZoneId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          warehouseZoneId?: string
        }
        Relationships: [
          {
            foreignKeyName: "warehouse_zone_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_zone_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_zone_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_zone_notes_warehouse_zone_id_warehouse_zones_id_fkey"
            columns: ["warehouseZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
        ]
      }
      warehouseZones: {
        Row: {
          createdAt: string
          createdBy: string | null
          description: string | null
          followUpZoneId: string | null
          id: string
          name: string
          number: number
          orgId: string
          type: Database["public"]["Enums"]["warehouseZoneType"]
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          description?: string | null
          followUpZoneId?: string | null
          id?: string
          name: string
          number?: number
          orgId?: string
          type?: Database["public"]["Enums"]["warehouseZoneType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          description?: string | null
          followUpZoneId?: string | null
          id?: string
          name?: string
          number?: number
          orgId?: string
          type?: Database["public"]["Enums"]["warehouseZoneType"]
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "warehouse_zones_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_zones_follow_up_zone_id_warehouse_zones_id_fkey"
            columns: ["followUpZoneId"]
            isOneToOne: false
            referencedRelation: "warehouseZones"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_zones_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "warehouse_zones_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      weather: {
        Row: {
          apparentTemperature: number
          cityId: string
          createdAt: string
          date: string
          humidity: number
          id: string
          main: boolean
          precipitation: number
          source: Database["public"]["Enums"]["weatherSource"]
          temperature: number
          weatherCode: number
          windDirection: number
          windSpeed: number
        }
        Insert: {
          apparentTemperature: number
          cityId?: string
          createdAt?: string
          date: string
          humidity: number
          id?: string
          main?: boolean
          precipitation: number
          source: Database["public"]["Enums"]["weatherSource"]
          temperature: number
          weatherCode: number
          windDirection: number
          windSpeed: number
        }
        Update: {
          apparentTemperature?: number
          cityId?: string
          createdAt?: string
          date?: string
          humidity?: number
          id?: string
          main?: boolean
          precipitation?: number
          source?: Database["public"]["Enums"]["weatherSource"]
          temperature?: number
          weatherCode?: number
          windDirection?: number
          windSpeed?: number
        }
        Relationships: [
          {
            foreignKeyName: "weather_city_id_city_coordinates_id_fkey"
            columns: ["cityId"]
            isOneToOne: false
            referencedRelation: "cityCoordinates"
            referencedColumns: ["id"]
          },
        ]
      }
      wikiPageFiles: {
        Row: {
          createdAt: string
          createdBy: string | null
          fileId: string
          id: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
          wikiPageId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          fileId: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          wikiPageId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          fileId?: string
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          wikiPageId?: string
        }
        Relationships: [
          {
            foreignKeyName: "wiki_page_files_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_files_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_files_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_files_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_files_wiki_page_id_wiki_pages_id_fkey"
            columns: ["wikiPageId"]
            isOneToOne: false
            referencedRelation: "wikiPages"
            referencedColumns: ["id"]
          },
        ]
      }
      wikiPageNotes: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          id: string
          noteId: string
          orgId: string
          wikiPageId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId: string
          orgId?: string
          wikiPageId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          noteId?: string
          orgId?: string
          wikiPageId?: string
        }
        Relationships: [
          {
            foreignKeyName: "wiki_page_notes_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_notes_note_id_notes_id_fkey"
            columns: ["noteId"]
            isOneToOne: false
            referencedRelation: "notes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_notes_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_notes_wiki_page_id_wiki_pages_id_fkey"
            columns: ["wikiPageId"]
            isOneToOne: false
            referencedRelation: "wikiPages"
            referencedColumns: ["id"]
          },
        ]
      }
      wikiPages: {
        Row: {
          content: string
          createdAt: string | null
          createdBy: string | null
          id: string
          orgId: string | null
          parentPageId: string | null
          spaceId: string
          title: string | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          content?: string
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          parentPageId?: string | null
          spaceId: string
          title?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          content?: string
          createdAt?: string | null
          createdBy?: string | null
          id?: string
          orgId?: string | null
          parentPageId?: string | null
          spaceId?: string
          title?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "wiki_pages_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_pages_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_pages_parent_page_id_fkey"
            columns: ["parentPageId"]
            isOneToOne: false
            referencedRelation: "wikiPages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_pages_space_id_wiki_spaces_id_fkey"
            columns: ["spaceId"]
            isOneToOne: false
            referencedRelation: "wikiSpaces"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_pages_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      wikiPageVideos: {
        Row: {
          createdAt: string
          createdBy: string | null
          id: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
          videoId: string
          wikiPageId: string
        }
        Insert: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          videoId: string
          wikiPageId: string
        }
        Update: {
          createdAt?: string
          createdBy?: string | null
          id?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
          videoId?: string
          wikiPageId?: string
        }
        Relationships: [
          {
            foreignKeyName: "wiki_page_videos_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_videos_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_videos_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_videos_video_id_videos_id_fkey"
            columns: ["videoId"]
            isOneToOne: false
            referencedRelation: "videos"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_page_videos_wiki_page_id_wiki_pages_id_fkey"
            columns: ["wikiPageId"]
            isOneToOne: false
            referencedRelation: "wikiPages"
            referencedColumns: ["id"]
          },
        ]
      }
      wikiSpaces: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string | null
          createdBy: string | null
          description: string | null
          iconName: Database["public"]["Enums"]["iconName"] | null
          id: string
          name: string
          orgId: string | null
          updatedAt: string | null
          updatedBy: string | null
          visibility: Database["public"]["Enums"]["visibility"]
        }
        Insert: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string | null
          createdBy?: string | null
          description?: string | null
          iconName?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name: string
          orgId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          visibility?: Database["public"]["Enums"]["visibility"]
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string | null
          createdBy?: string | null
          description?: string | null
          iconName?: Database["public"]["Enums"]["iconName"] | null
          id?: string
          name?: string
          orgId?: string | null
          updatedAt?: string | null
          updatedBy?: string | null
          visibility?: Database["public"]["Enums"]["visibility"]
        }
        Relationships: [
          {
            foreignKeyName: "wiki_spaces_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_spaces_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "wiki_spaces_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      workspaceMeta: {
        Row: {
          bankAccountHolder: string | null
          bic: string | null
          businessHours: Json | null
          city: string | null
          companyName: string | null
          email: string | null
          houseNumber: string | null
          iban: string | null
          id: string
          legal: Json | null
          orgId: string
          phone: string | null
          region: Database["public"]["Enums"]["region"] | null
          streetName: string | null
          web: string | null
          workspaceId: string
          zipCode: string | null
        }
        Insert: {
          bankAccountHolder?: string | null
          bic?: string | null
          businessHours?: Json | null
          city?: string | null
          companyName?: string | null
          email?: string | null
          houseNumber?: string | null
          iban?: string | null
          id?: string
          legal?: Json | null
          orgId?: string
          phone?: string | null
          region?: Database["public"]["Enums"]["region"] | null
          streetName?: string | null
          web?: string | null
          workspaceId?: string
          zipCode?: string | null
        }
        Update: {
          bankAccountHolder?: string | null
          bic?: string | null
          businessHours?: Json | null
          city?: string | null
          companyName?: string | null
          email?: string | null
          houseNumber?: string | null
          iban?: string | null
          id?: string
          legal?: Json | null
          orgId?: string
          phone?: string | null
          region?: Database["public"]["Enums"]["region"] | null
          streetName?: string | null
          web?: string | null
          workspaceId?: string
          zipCode?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "workspace_meta_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspace_meta_workspace_id_workspaces_id_fkey"
            columns: ["workspaceId"]
            isOneToOne: true
            referencedRelation: "workspaces"
            referencedColumns: ["id"]
          },
        ]
      }
      workspaceMetaMedia: {
        Row: {
          createdAt: string | null
          createdBy: string | null
          fileId: string | null
          id: string
          orgId: string | null
          type: Database["public"]["Enums"]["workspaceMetaMediaType"]
          updatedAt: string | null
          updatedBy: string | null
          workspaceMetaId: string
        }
        Insert: {
          createdAt?: string | null
          createdBy?: string | null
          fileId?: string | null
          id?: string
          orgId?: string | null
          type: Database["public"]["Enums"]["workspaceMetaMediaType"]
          updatedAt?: string | null
          updatedBy?: string | null
          workspaceMetaId: string
        }
        Update: {
          createdAt?: string | null
          createdBy?: string | null
          fileId?: string | null
          id?: string
          orgId?: string | null
          type?: Database["public"]["Enums"]["workspaceMetaMediaType"]
          updatedAt?: string | null
          updatedBy?: string | null
          workspaceMetaId?: string
        }
        Relationships: [
          {
            foreignKeyName: "workspace_meta_media_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspace_meta_media_file_id_files_id_fkey"
            columns: ["fileId"]
            isOneToOne: false
            referencedRelation: "files"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspace_meta_media_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspace_meta_media_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspace_meta_media_workspace_meta_id_workspace_meta_id_fkey"
            columns: ["workspaceMetaId"]
            isOneToOne: false
            referencedRelation: "workspaceMeta"
            referencedColumns: ["id"]
          },
        ]
      }
      workspaces: {
        Row: {
          color: Database["public"]["Enums"]["color"]
          createdAt: string
          createdBy: string | null
          id: string
          name: string
          orgId: string
          updatedAt: string | null
          updatedBy: string | null
        }
        Insert: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          id?: string
          name: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Update: {
          color?: Database["public"]["Enums"]["color"]
          createdAt?: string
          createdBy?: string | null
          id?: string
          name?: string
          orgId?: string
          updatedAt?: string | null
          updatedBy?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "workspaces_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspaces_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "workspaces_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      organizationServicesWithFullNumber: {
        Row: {
          ancestorIds: string[] | null
          createdAt: string | null
          createdBy: string | null
          fulfillmentType:
            | Database["public"]["Enums"]["serviceFulfillmentType"]
            | null
          fullNumber: string | null
          id: string | null
          longText: string | null
          number: number | null
          orgId: string | null
          parentServiceId: string | null
          shortText: string | null
          unit: Database["public"]["Enums"]["unit"] | null
          updatedAt: string | null
          updatedBy: string | null
        }
        Relationships: [
          {
            foreignKeyName: "organization_services_created_by_users_id_fkey"
            columns: ["createdBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_org_id_organizations_id_fkey"
            columns: ["orgId"]
            isOneToOne: false
            referencedRelation: "organizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_parent_service_id_fkey"
            columns: ["parentServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServices"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_parent_service_id_fkey"
            columns: ["parentServiceId"]
            isOneToOne: false
            referencedRelation: "organizationServicesWithFullNumber"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "organization_services_updated_by_users_id_fkey"
            columns: ["updatedBy"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Functions: {
      calculation_is_locked: {
        Args: { calculation_id: string }
        Returns: boolean
      }
      calculation_item_is_locked: {
        Args: { item_id: string }
        Returns: boolean
      }
      camel_key: { Args: { key: string }; Returns: string }
      camel_keys: { Args: { doc: Json }; Returns: Json }
      create_stock_balance_history: { Args: never; Returns: undefined }
      foreign_keys_to_projects: {
        Args: never
        Returns: {
          columnName: string
          tableName: string
          tableSchema: string
          uniqueWith: string[]
        }[]
      }
      generate_4_digit_code: { Args: never; Returns: string }
      generate_8_digit_code: { Args: never; Returns: string }
      get_date_string: { Args: { input_date?: string }; Returns: string }
      get_user_activity: {
        Args: { p_user_id: string }
        Returns: {
          activity_type: string
          item_id: string
          table_name: string
          timestamp: string
          user_id: string
        }[]
      }
      partner_report_receiving_accounts: {
        Args: { p_partner_report_id: string }
        Returns: {
          bic: string
          iban: string
        }[]
      }
      percent_encode: { Args: { input: string }; Returns: string }
      record_incoming_invoice_event: {
        Args: {
          p_incoming_invoice_id: string
          p_item?: Json
          p_occurred_at?: string
          p_payload?: Json
          p_type: Database["public"]["Enums"]["incomingInvoiceEventType"]
        }
        Returns: undefined
      }
      reorder_ticket_assignments: {
        Args: { crew_id: string }
        Returns: undefined
      }
      requesting_actor_id: { Args: never; Returns: string }
      requesting_org_id: { Args: never; Returns: string }
      requesting_user_id: { Args: never; Returns: string }
      requesting_user_may_read_partner_names: { Args: never; Returns: boolean }
      update_partnership_invitation_codes: { Args: never; Returns: undefined }
    }
    Enums: {
      absenceCategory: "vacation" | "sick" | "leave" | "compensation"
      absenceState: "pending" | "approved" | "rejected" | "cancelled"
      alertLevelType: "success" | "warning" | "danger" | "info" | "neutral"
      assignmentCalculationType: "hourly" | "service"
      attendanceSource: "web" | "mobile" | "terminal" | "system"
      attendanceState: "pending" | "approved" | "rejected"
      attendanceType: "work" | "break"
      attendanceWorksiteType:
        | "home-office"
        | "office"
        | "project-site"
        | "warehouse"
        | "commute"
      bookingResult: "accepted" | "adjusted" | "rejected"
      calculationLockSource: "manual" | "approval"
      calculationState: "pending" | "locked"
      calculationType: "parsc" | "offer"
      color:
        | "emerald"
        | "rose"
        | "red"
        | "violet"
        | "purple"
        | "indigo"
        | "gray"
        | "teal"
        | "amber"
        | "yellow"
        | "orange"
        | "blue"
        | "primary"
        | "cyan"
        | "lime"
        | "salmon"
        | "fern"
        | "green"
        | "azure"
        | "sky"
        | "jade"
        | "slate"
        | "zinc"
        | "stone"
        | "ember-blaze"
        | "accent"
      contactBankAccountSource: "invoice" | "manual"
      cranePosition: "front" | "tail"
      dateMode: "date" | "week"
      documentKind:
        | "offer"
        | "measurement"
        | "delivery-note"
        | "protocol"
        | "risk-assessment"
        | "order"
        | "other"
      documentType: "default" | "risk-assessment"
      emailPreferencesType: "unsubscribe" | "unsubscribe-all"
      emailProvider: "resend"
      emailType:
        | "partner-report"
        | "substitution-external-note"
        | "substitution-done-external-note"
        | "substitution-internal-note"
        | "substitution-done-internal-note"
        | "verify-email"
        | "reset-password"
        | "password-email"
        | "substitution-team-note"
        | "protocol"
        | "note-mention"
        | "protocol-involvement"
        | "order-complete"
        | "project-assigned"
        | "project-number-changed"
        | "incoming-invoice-review-requested"
        | "incoming-invoice-review-decided"
        | "partnership-requested"
        | "partnership-activated"
        | "partnership-deactivated"
      fileClassificationState:
        | "queued"
        | "extracting"
        | "classifying"
        | "linked"
        | "unplaced"
        | "failed"
      fuelType: "diesel" | "petrol" | "electric" | "hybrid" | "other"
      iconName:
        | "arrow-up"
        | "arrow-down"
        | "arrow-left"
        | "arrow-right"
        | "arrow-wave-right"
        | "arrow-wave-left"
        | "arrows-diff"
        | "arrows-split"
        | "arrows-random"
        | "bulb"
        | "bolt"
        | "circle"
        | "circle-dashed"
        | "circle-dotted"
        | "folder"
      incomingEmailFileInvoiceCheckState:
        | "pending"
        | "checked"
        | "skipped"
        | "failed"
      incomingEmailFileInvoiceKind:
        | "invoice"
        | "partial-invoice"
        | "final-invoice"
        | "credit-note"
        | "reminder"
        | "delivery-note"
        | "other"
      incomingEmailOutcome: "stored" | "skipped" | "failed"
      incomingEmailProcessingState:
        | "queued"
        | "started"
        | "completed"
        | "skipped"
        | "failed"
      incomingInvoiceApprovalAssignment: "default" | "assigned"
      incomingInvoiceApprovalState:
        | "pending"
        | "approved"
        | "rejected"
        | "skipped"
      incomingInvoiceCheckState: "passed" | "failed" | "skipped"
      incomingInvoiceCostAllocationSource: "suggested" | "manual"
      incomingInvoiceEInvoiceFormat: "zugferd" | "xrechnung"
      incomingInvoiceEventType:
        | "received"
        | "read"
        | "read_failed"
        | "checked"
        | "approval_requested"
        | "approved"
        | "rejected"
        | "decision_taken_back"
        | "state_changed"
        | "cost_allocation_suggested"
        | "cost_allocation_changed"
        | "cost_allocation_cleared"
        | "field_changed"
        | "duplicate_detected"
        | "duplicate_dismissed"
        | "duplicate_merged"
        | "merged_into"
        | "reminder_received"
        | "approval_withdrawn"
        | "payment_exported"
        | "payment_reverted"
        | "iban_confirmed"
        | "approval_skipped"
        | "amount_reduced"
        | "approvals_reset"
        | "reduction_lifted"
        | "delivery_note_linked"
        | "delivery_note_unlinked"
      incomingInvoiceExtractionState: "extracted" | "failed"
      incomingInvoiceKind:
        | "invoice"
        | "partial-invoice"
        | "final-invoice"
        | "credit-note"
      incomingInvoicePaymentFormat: "pain.001.001.09" | "pain.001.001.03"
      incomingInvoiceState:
        | "received"
        | "approved"
        | "paid"
        | "rejected"
        | "duplicate"
        | "merged"
      integrationType: "personio" | "webfleet"
      invitationState: "pending" | "accepted" | "rejected"
      mailboxHealth: "ok" | "failing" | "needs-attention"
      mailboxImapSecurity: "tls" | "starttls"
      mailboxPurpose: "incoming-invoices"
      notificationKind:
        | "note-mention"
        | "protocol-involvement"
        | "project-assigned"
        | "project-number-changed"
        | "order-complete"
        | "plan-published"
        | "attendance-decided"
        | "substitution-assigned"
        | "substitution-team-note"
        | "substitution-external-note"
        | "partner-report"
        | "incoming-invoice-review-requested"
        | "incoming-invoice-review-decided"
        | "partnership-requested"
        | "partnership-activated"
        | "partnership-deactivated"
      notificationType:
        | "plan"
        | "attendance"
        | "order"
        | "note"
        | "protocol"
        | "substitution"
        | "project"
        | "incoming-invoice"
        | "partner"
      operation: "UPDATE" | "INSERT" | "DELETE" | "MERGE"
      orderArticleState: "fulfilled" | "partial" | "open"
      orderImportFileField: "quantity" | "identifier"
      orderState:
        | "pending"
        | "picking"
        | "complete"
        | "open"
        | "in-progress"
        | "canceled"
      organizationPartnershipAgreementType:
        | "hourly-rate"
        | "early-payment-discount"
        | "early-payment-discount-payment-target"
        | "payment-target"
        | "service"
      organizationPartnershipsState: "active" | "inactive" | "pending"
      outgoingInvoiceState: "pending" | "paid" | "overdue"
      outgoingInvoiceType:
        | "single-invoice"
        | "progress-invoice"
        | "final-invoice"
      partnerReportState: "pending" | "approved"
      personTitle: "mr" | "mrs"
      planState: "pending" | "published" | "editing"
      priority: "very-high" | "high" | "medium" | "low" | "custom"
      projectRole: "manager" | "deputy-manager"
      projectState: "active" | "inactive" | "archived"
      protocolCallRequestEventType: "resolved" | "unreachable"
      pushTokenProvider: "expo"
      region:
        | "BW"
        | "BY"
        | "BE"
        | "BB"
        | "HB"
        | "HE"
        | "HH"
        | "MV"
        | "NI"
        | "NW"
        | "RP"
        | "SL"
        | "SN"
        | "ST"
        | "SH"
        | "TH"
      resourceLinkType: "trimble"
      returnOrderState: "open" | "in-progress" | "complete" | "canceled"
      scope: "global" | "user"
      serviceCalculationItemType: "service" | "block"
      serviceCalculationMemberSource: "offer-match" | "manual"
      serviceFulfillmentType: "internal" | "external"
      state: "active" | "inactive" | "pending"
      stockTransactionOperation: "ADD" | "REMOVE"
      teamCapability:
        | "receive-substitution-list-copy"
        | "crew-scheduling"
        | "vehicle-scheduling"
        | "manage-project"
        | "invoice-approval"
      terminalPairingState: "pending" | "approved"
      ticketAssignmentMeasurementStatement:
        | "without-charge"
        | "remember"
        | "included"
      ticketAssignmentReferencesState: "pending" | "approved"
      ticketTypeState: "active" | "inactive"
      transactionType:
        | "pick"
        | "correction"
        | "inventory"
        | "restock"
        | "return"
      transportOrderEvent:
        | "raised"
        | "picked-up"
        | "taken-over"
        | "delivered"
        | "canceled"
      transportOrderState: "pending" | "in-transit" | "complete" | "canceled"
      unit:
        | "percent"
        | "number"
        | "calendar-days"
        | "business-days"
        | "weeks"
        | "work-days"
        | "millimeters"
        | "centimeters"
        | "meters"
        | "kilometers"
        | "square-meters"
        | "cubic-meters"
        | "currency"
        | "days"
        | "piece"
        | "flat-rate"
        | "kilogram"
        | "gram"
        | "ton"
        | "piece-week"
        | "meters-week"
        | "square-meters-week"
      userState: "active" | "inactive"
      vacationDaysAccrualType: "upfront" | "monthly"
      vehicleType: "truck" | "pickup" | "van" | "car" | "trailer" | "other"
      videoStatus: "uploading" | "processing" | "ready" | "errored"
      visibility: "public" | "private" | "restricted"
      warehouseLocationType: "block" | "bin"
      warehouseZoneType:
        | "storage"
        | "staging"
        | "consolidation"
        | "shipping"
        | "receiving"
      weatherSource: "open-meteo"
      workspaceMetaMediaType: "logo" | "letter-paper"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
        DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] &
        DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  public: {
    Enums: {
      absenceCategory: ["vacation", "sick", "leave", "compensation"],
      absenceState: ["pending", "approved", "rejected", "cancelled"],
      alertLevelType: ["success", "warning", "danger", "info", "neutral"],
      assignmentCalculationType: ["hourly", "service"],
      attendanceSource: ["web", "mobile", "terminal", "system"],
      attendanceState: ["pending", "approved", "rejected"],
      attendanceType: ["work", "break"],
      attendanceWorksiteType: [
        "home-office",
        "office",
        "project-site",
        "warehouse",
        "commute",
      ],
      bookingResult: ["accepted", "adjusted", "rejected"],
      calculationLockSource: ["manual", "approval"],
      calculationState: ["pending", "locked"],
      calculationType: ["parsc", "offer"],
      color: [
        "emerald",
        "rose",
        "red",
        "violet",
        "purple",
        "indigo",
        "gray",
        "teal",
        "amber",
        "yellow",
        "orange",
        "blue",
        "primary",
        "cyan",
        "lime",
        "salmon",
        "fern",
        "green",
        "azure",
        "sky",
        "jade",
        "slate",
        "zinc",
        "stone",
        "ember-blaze",
        "accent",
      ],
      contactBankAccountSource: ["invoice", "manual"],
      cranePosition: ["front", "tail"],
      dateMode: ["date", "week"],
      documentKind: [
        "offer",
        "measurement",
        "delivery-note",
        "protocol",
        "risk-assessment",
        "order",
        "other",
      ],
      documentType: ["default", "risk-assessment"],
      emailPreferencesType: ["unsubscribe", "unsubscribe-all"],
      emailProvider: ["resend"],
      emailType: [
        "partner-report",
        "substitution-external-note",
        "substitution-done-external-note",
        "substitution-internal-note",
        "substitution-done-internal-note",
        "verify-email",
        "reset-password",
        "password-email",
        "substitution-team-note",
        "protocol",
        "note-mention",
        "protocol-involvement",
        "order-complete",
        "project-assigned",
        "project-number-changed",
        "incoming-invoice-review-requested",
        "incoming-invoice-review-decided",
        "partnership-requested",
        "partnership-activated",
        "partnership-deactivated",
      ],
      fileClassificationState: [
        "queued",
        "extracting",
        "classifying",
        "linked",
        "unplaced",
        "failed",
      ],
      fuelType: ["diesel", "petrol", "electric", "hybrid", "other"],
      iconName: [
        "arrow-up",
        "arrow-down",
        "arrow-left",
        "arrow-right",
        "arrow-wave-right",
        "arrow-wave-left",
        "arrows-diff",
        "arrows-split",
        "arrows-random",
        "bulb",
        "bolt",
        "circle",
        "circle-dashed",
        "circle-dotted",
        "folder",
      ],
      incomingEmailFileInvoiceCheckState: [
        "pending",
        "checked",
        "skipped",
        "failed",
      ],
      incomingEmailFileInvoiceKind: [
        "invoice",
        "partial-invoice",
        "final-invoice",
        "credit-note",
        "reminder",
        "delivery-note",
        "other",
      ],
      incomingEmailOutcome: ["stored", "skipped", "failed"],
      incomingEmailProcessingState: [
        "queued",
        "started",
        "completed",
        "skipped",
        "failed",
      ],
      incomingInvoiceApprovalAssignment: ["default", "assigned"],
      incomingInvoiceApprovalState: [
        "pending",
        "approved",
        "rejected",
        "skipped",
      ],
      incomingInvoiceCheckState: ["passed", "failed", "skipped"],
      incomingInvoiceCostAllocationSource: ["suggested", "manual"],
      incomingInvoiceEInvoiceFormat: ["zugferd", "xrechnung"],
      incomingInvoiceEventType: [
        "received",
        "read",
        "read_failed",
        "checked",
        "approval_requested",
        "approved",
        "rejected",
        "decision_taken_back",
        "state_changed",
        "cost_allocation_suggested",
        "cost_allocation_changed",
        "cost_allocation_cleared",
        "field_changed",
        "duplicate_detected",
        "duplicate_dismissed",
        "duplicate_merged",
        "merged_into",
        "reminder_received",
        "approval_withdrawn",
        "payment_exported",
        "payment_reverted",
        "iban_confirmed",
        "approval_skipped",
        "amount_reduced",
        "approvals_reset",
        "reduction_lifted",
        "delivery_note_linked",
        "delivery_note_unlinked",
      ],
      incomingInvoiceExtractionState: ["extracted", "failed"],
      incomingInvoiceKind: [
        "invoice",
        "partial-invoice",
        "final-invoice",
        "credit-note",
      ],
      incomingInvoicePaymentFormat: ["pain.001.001.09", "pain.001.001.03"],
      incomingInvoiceState: [
        "received",
        "approved",
        "paid",
        "rejected",
        "duplicate",
        "merged",
      ],
      integrationType: ["personio", "webfleet"],
      invitationState: ["pending", "accepted", "rejected"],
      mailboxHealth: ["ok", "failing", "needs-attention"],
      mailboxImapSecurity: ["tls", "starttls"],
      mailboxPurpose: ["incoming-invoices"],
      notificationKind: [
        "note-mention",
        "protocol-involvement",
        "project-assigned",
        "project-number-changed",
        "order-complete",
        "plan-published",
        "attendance-decided",
        "substitution-assigned",
        "substitution-team-note",
        "substitution-external-note",
        "partner-report",
        "incoming-invoice-review-requested",
        "incoming-invoice-review-decided",
        "partnership-requested",
        "partnership-activated",
        "partnership-deactivated",
      ],
      notificationType: [
        "plan",
        "attendance",
        "order",
        "note",
        "protocol",
        "substitution",
        "project",
        "incoming-invoice",
        "partner",
      ],
      operation: ["UPDATE", "INSERT", "DELETE", "MERGE"],
      orderArticleState: ["fulfilled", "partial", "open"],
      orderImportFileField: ["quantity", "identifier"],
      orderState: [
        "pending",
        "picking",
        "complete",
        "open",
        "in-progress",
        "canceled",
      ],
      organizationPartnershipAgreementType: [
        "hourly-rate",
        "early-payment-discount",
        "early-payment-discount-payment-target",
        "payment-target",
        "service",
      ],
      organizationPartnershipsState: ["active", "inactive", "pending"],
      outgoingInvoiceState: ["pending", "paid", "overdue"],
      outgoingInvoiceType: [
        "single-invoice",
        "progress-invoice",
        "final-invoice",
      ],
      partnerReportState: ["pending", "approved"],
      personTitle: ["mr", "mrs"],
      planState: ["pending", "published", "editing"],
      priority: ["very-high", "high", "medium", "low", "custom"],
      projectRole: ["manager", "deputy-manager"],
      projectState: ["active", "inactive", "archived"],
      protocolCallRequestEventType: ["resolved", "unreachable"],
      pushTokenProvider: ["expo"],
      region: [
        "BW",
        "BY",
        "BE",
        "BB",
        "HB",
        "HE",
        "HH",
        "MV",
        "NI",
        "NW",
        "RP",
        "SL",
        "SN",
        "ST",
        "SH",
        "TH",
      ],
      resourceLinkType: ["trimble"],
      returnOrderState: ["open", "in-progress", "complete", "canceled"],
      scope: ["global", "user"],
      serviceCalculationItemType: ["service", "block"],
      serviceCalculationMemberSource: ["offer-match", "manual"],
      serviceFulfillmentType: ["internal", "external"],
      state: ["active", "inactive", "pending"],
      stockTransactionOperation: ["ADD", "REMOVE"],
      teamCapability: [
        "receive-substitution-list-copy",
        "crew-scheduling",
        "vehicle-scheduling",
        "manage-project",
        "invoice-approval",
      ],
      terminalPairingState: ["pending", "approved"],
      ticketAssignmentMeasurementStatement: [
        "without-charge",
        "remember",
        "included",
      ],
      ticketAssignmentReferencesState: ["pending", "approved"],
      ticketTypeState: ["active", "inactive"],
      transactionType: ["pick", "correction", "inventory", "restock", "return"],
      transportOrderEvent: [
        "raised",
        "picked-up",
        "taken-over",
        "delivered",
        "canceled",
      ],
      transportOrderState: ["pending", "in-transit", "complete", "canceled"],
      unit: [
        "percent",
        "number",
        "calendar-days",
        "business-days",
        "weeks",
        "work-days",
        "millimeters",
        "centimeters",
        "meters",
        "kilometers",
        "square-meters",
        "cubic-meters",
        "currency",
        "days",
        "piece",
        "flat-rate",
        "kilogram",
        "gram",
        "ton",
        "piece-week",
        "meters-week",
        "square-meters-week",
      ],
      userState: ["active", "inactive"],
      vacationDaysAccrualType: ["upfront", "monthly"],
      vehicleType: ["truck", "pickup", "van", "car", "trailer", "other"],
      videoStatus: ["uploading", "processing", "ready", "errored"],
      visibility: ["public", "private", "restricted"],
      warehouseLocationType: ["block", "bin"],
      warehouseZoneType: [
        "storage",
        "staging",
        "consolidation",
        "shipping",
        "receiving",
      ],
      weatherSource: ["open-meteo"],
      workspaceMetaMediaType: ["logo", "letter-paper"],
    },
  },
} as const

